<template>
    <div id="asset_group_create">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vehiclegroupHeader">Reservation Details</span>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="web-action-btn btn-groups text-right" v-for="(BookData, key) in RentedTrucksArr" :key="key">
                        <div v-for="(tData, trkey) in TrucksArr" :key="trkey" >
                            <button type="submit" class="btn btn-secondary " v-on:click.prevent="BackReservationList">
                            <i class="fp-back"> </i> Back
                            </button>
                            <button type="cancel" class="btn btn-secondary " v-on:click="deleteSelectedTruck( tData.reservationId, BookData.bookingId, $event)" v-if="tData.status == 0 && tData.actual == 'false' && canCancelReservation && !tData.agreement_id">
                                <i class="fp-close"></i>Cancel
                            </button>
                            <button type="edit" class="btn btn-primary" v-on:click="updateReservation()"  v-if="canUpdateReservation && !tData.agreement_id">
                                <i class="fp-edit-icon"></i> Edit
                            </button>                        
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content reservation-details">
                        <div :class="`loader${loaderClass}`" v-show="loading"></div>
                        <section class="internal-container border-top-table-fl">
                            <template v-for="(BookData, key) in RentedTrucksArr">
                                <div class="details-page-container view-details-page-container" :key="key">
                                    <div class="form-row">
                                        <div class="col-md-6">
                                            <div class="title">Customer Name :</div>
                                            <span class="mt-2 display-block">{{BookData.customerNo}} | {{BookData.company_name}} | {{BookData.customerStage}}</span>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="title">Phone :</div>
                                            <span class="mt-2 display-block">{{BookData.user_phone}}</span>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="title">Email :</div>
                                            <span class="mt-2 display-block">{{BookData.user_username}}</span>
                                        </div>
                                    </div>
                                    <label class="color-red" v-if="BookData.cancelled == 1">Reservation Cancelled</label>
                                    <div class="reserved-vehicle-info mt-3">
                                        <template v-for="(truckData, tkey) in RentedTrucksArr[key]['trucks']">
                                            <a :key="tkey" class="truck-badge mt-3 ml-lg-3 mr-3" :id="'truck_badge_'+truckData.reservId" href="javascript:void(0)" v-on:click="GetTruckData(truckData.reservId)">
                                                <div class="admin-truck-img">
                                                    <template v-if="truckData.image != ''">
                                                        <template  v-for="(uFile,fKey) in truckData.image">
                                                            <img  v-bind:key="fKey" :src="uFile.url" alt="">
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <img src="/static/images/truck-img.jpg" alt="">
                                                    </template>
                                                </div>
                                                <div class="admin-truck-text">
                                                    <template v-if="truckData.unit_no == '0'">
                                                        <span>{{ truckData.name }}</span>
                                                    </template>
                                                    <template v-else>
                                                        <span>{{ truckData.unit_no }}</span>
                                                    </template>

                                                    <div class="selected-truck-date">
                                                        <p>From: {{ truckData.from_date[0] }}</p>
                                                        <p class="text-right">To: {{ truckData.to_date[0] }}</p>
                                                    </div>
                                                </div>
                                            </a>
                                        </template>
                                    </div>
                                    <template v-for="(tData, trkey) in TrucksArr">
                                        <div :key="trkey" class="reserved-details">
                                            <div class="reserved-vehicle-details p-lg-4 p-3">
                                                <lable style="color:green" v-if="tData.settle_status == 1">Reservation Settled</lable>
                                                <div class="top-enrich-section">
                                                    <label class="mr-2">Current Status:</label> <span class="current-status" v-show="enrichStatusSpan">&nbsp;{{ hideCurrentStatusView(tData.resStatus) }}</span>
                                                    <div class="enrich-input-tab" v-if="!hideUpdateCurrentStatus && canChangeReservationStatus">
                                                        <a href="javascript:void(0)" title="Update" v-show="editStatusInput" v-on:click="CurrentStatus =  tData.resStatus, viewStatusInput = true, editStatusInput = false,enrichStatusSpan = false"><i class="fp-edit" aria-hidden="true"></i></a>
                                                        <div class="enrich-input" v-show="viewStatusInput">
                                                            <v-select v-model="CurrentStatus" class="custom-vselect" id="statusInput" label="text" :options="statusArr"></v-select>
                                                            <button class="btn btn-primary" id="updateStatusBtn" v-on:click="updateReservationDetail(tData.reservationId, tData.id, 'status')">Save</button>
                                                            <a class="close-input" href="javascript:void(0)" v-on:click="viewStatusInput = false, editStatusInput = true, enrichStatusSpan = true, statusErr = ''"><i class="fp-add" aria-hidden="true"></i></a>
                                                            <div class="field-error">{{statusErr}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="tData.credit_override_request_status != ''">
                                                    <label class="">Credit Override Req. Status:</label>
                                                    <span class="col"><span v-if="tData.credit_override_request_status == 'sent'" class="badge badge-warning">{{ titleCase(tData.credit_override_request_status) }}</span>
                                                    <span v-if="tData.credit_override_request_status == 'approved'" class="badge badge-success">{{ titleCase(tData.credit_override_request_status) }}</span>
                                                    <span v-if="tData.credit_override_request_status == 'denied'" class="badge badge-danger">{{ titleCase(tData.credit_override_request_status) }}</span>
                                                    </span>
                                                </div>
                                                <button type="submit" class="btn btn-primary pull-right" v-if="tData.cancelled != 1 && tData.resStatus == 'Active' && !tData.agreement_id && tData.contractType.toLowerCase() == 'rental' && (tData.credit_override_request_status == '' || tData.credit_override_request_status == 'approved')" v-on:click.prevent="createAgreement(tData.reservationId)">
                                                    Create Agreement
                                                </button>
                                                <div class="reference-number mt-4">
                                                    Reference No:  <span>#{{tData.reference_no}} <lable style="color:red" v-if="tData.cancelled == 1"> (Cancelled)</lable></span>
                                                </div>
                                                <div class="reference-number mt-2" v-if="tData.agreement_code && tData.contractType.toLowerCase() == 'rental'">
                                                    Agreement No: <a href="javascript:void(0)" class="color-blue" v-on:click="viewRentalAgreement(tData.agreement_id)">#{{tData.agreement_code}}</a>
                                                </div>
                                                <div class="flexibility-details">
                                                    <span>Flexible Location: {{tData.flex_location}}</span>
                                                    <span>Flexible Date: {{tData.flex_date}}</span>
                                                    <span>Rental Type: {{tData.contractType}}</span>
                                                    <span>Contract Type: {{tData.conTypename}}</span>
                                                </div>
                                                <div class="edit-delete-icons" v-if="BookData.cancelled == 0 && tData.cancelled == 0 && tData.resStatus != 'Closed'">
                                                    <a href='javascript:void(0)' class="pull-right edit-icon" v-on:click="updateReservation()"  v-if="canUpdateReservation && !tData.agreement_id">
                                                        <i class="fp-edit color-blue"></i>
                                                    </a>
                                                    <a href="javascript:void(0)"  class="pull-right delete-icon mr-3"
                                                        v-on:click="deleteSelectedTruck( tData.reservationId, BookData.bookingId, $event)" v-if="tData.status == 0 && tData.actual == 'false' && canCancelReservation && !tData.agreement_id">
                                                            <i class="fp-delete color-red"></i>
                                                    </a>

                                                </div>
                                                <div class="rental-truck-block mt-2 mb-3 pull-left">
                                                    <div class="rental-period-border">
                                                        <i class="fp-truck" aria-hidden="true"></i>
                                                    </div>
                                                    <div class="location pull-left">
                                                        <span><b class="font-bold color-black">From:</b> {{tData.fromLocation}}</span>
                                                        <p>{{tData.pickup_date}} {{tData.pickup_time}}</p>
                                                    </div>
                                                    <div class="location pull-right text-right">
                                                        <span><b class="font-bold color-black">To:</b> {{tData.toLocation}}</span>
                                                        <p class="text-right">{{tData.dropoff_date}} {{tData.dropoff_time}}</p>
                                                    </div>
                                                </div>
                                                <div class="order-summary-block row no-gutters">
                                                    <div class="col-md-8">
                                                        <div class="row no-gutters">
                                                            <div class="img-container col-md-5 mb-3" v-if="tData.truck_image != ''">
                                                                <template  v-for="(uFile,fKey) in tData.truck_image">
                                                                    <img v-bind:key="fKey" :src="uFile.url" alt="">
                                                                </template>
                                                            </div>
                                                            <div class="img-container col-md-5 mb-3" v-else>
                                                                <img src="/static/images/truck-img.jpg" alt="">
                                                            </div>
                                                            <div class="truck-info col-md-7 pl-lg-4 mb-3">
                                                                <h3 class="font-semibold" v-if="tData.unit_number != '0'">{{tData.unit_number}}</h3>
                                                                <h5>{{tData.truckTypeName}}</h5>
                                                                <div class="new-price-container mt-3 mb-3">
                                                                    <div class="price">
                                                                        <p>Estimated Miles :</p>
                                                                        <div class="new-price">
                                                                            {{tData.miles}} <small>Miles</small>
                                                                        </div>
                                                                    </div>
                                                                    <div class="price mt-3">
                                                                        <p>Actual Miles :</p>
                                                                        <div class="new-price">
                                                                            {{tData.distance}} <small>Miles</small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="pickup-address">
                                                                    <div class="address-title">Pickup Address</div>
                                                                    <div class="address">
                                                                        <template v-if="tData.addressLine1 != ''">
                                                                            {{tData.addressLine1}},<br>
                                                                        </template>
                                                                        <template v-if="tData.addressLine2 != ''">
                                                                            {{tData.addressLine2}},<br>
                                                                        </template>
                                                                        {{tData.city}}, {{tData.state}} &nbsp;
                                                                        {{tData.zip}}<br>
                                                                        {{tData.phone}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="detail-description">
                                                            <template v-for="(othrateArr , othratekey) in TrucksArr[trkey]['other_rates']">
                                                                <div :key="othratekey" class="table-view-detail">
                                                                    <div class="left-section" v-if="othrateArr.name === 'government_compliance'">Govt. Compliance :
                                                                        <div class="os-estimated-hours">
                                                                            $ {{numberFormat(othrateArr.rate) + " X " + othrateArr.unit + ' ' + othrateArr.type}}
                                                                        </div>
                                                                    </div>
                                                                    <div class="left-section" v-if="othrateArr.name === 'ENV'">Env. Compliance :
                                                                        <div class="os-estimated-hours">
                                                                            $ {{numberFormat(othrateArr.rate) + " X " + othrateArr.unit + ' ' + othrateArr.type}}
                                                                        </div>
                                                                    </div>
                                                                    <div class="left-section" v-else-if="othrateArr.section">{{othrateArr.section}} :
                                                                        <div class="os-estimated-hours">
                                                                            $ {{numberFormat(othrateArr.rate) + " X " + othrateArr.unit + ' ' + othrateArr.type}}
                                                                        </div>
                                                                    </div>
                                                                    <div class="left-section" v-else>{{othrateArr.name}} :
                                                                        <div class="os-estimated-hours">
                                                                            $ {{numberFormat(othrateArr.rate) + " X " + othrateArr.unit + ' ' + othrateArr.type}}
                                                                        </div>
                                                                    </div>
                                                                    <div class="right-section">$ {{ numberFormat(othrateArr.total)}}</div>
                                                                </div>
                                                            </template>

                                                            <!-- <div class="table-view-detail" v-if="TrucksArr[trkey]['insurance_rates']['phy_ins_charge'] != ''">
                                                                <div class="left-section">Physical Insurance :
                                                                    <div class="os-estimated-hours">
                                                                        $ {{numberFormat(TrucksArr[trkey]['insurance_rates']['phy_ins_charge']['rate']) + " X " + TrucksArr[trkey]['insurance_rates']['phy_ins_charge']['days'] + ' ' + TrucksArr[trkey]['insurance_rates']['phy_ins_charge']['type']}}
                                                                    </div>
                                                                </div>
                                                                <div class="right-section">$ {{numberFormat(TrucksArr[trkey]['insurance_rates']['phy_ins_charge']['total'])}}</div>
                                                            </div>
                                                            <div class="table-view-detail" v-if="TrucksArr[trkey]['insurance_rates']['lia_ins_charge'] != ''">
                                                                <div class="left-section">Liability Insurance :
                                                                    <div class="os-estimated-hours">
                                                                        $ {{numberFormat(TrucksArr[trkey]['insurance_rates']['lia_ins_charge']['rate']) + " X " + TrucksArr[trkey]['insurance_rates']['lia_ins_charge']['days'] + ' ' + TrucksArr[trkey]['insurance_rates']['lia_ins_charge']['type']}}
                                                                    </div>
                                                                </div>
                                                                <div class="right-section">$ {{numberFormat(TrucksArr[trkey]['insurance_rates']['lia_ins_charge']['total'])}}</div>
                                                            </div> -->
                                                            <div class="table-view-detail" v-if="TrucksArr[trkey]['insurance_rates'].admin_fee != 0">
                                                                <div class="left-section">Admin Fee :</div>
                                                                <div class="right-section">$ {{ numberFormat(TrucksArr[trkey]['insurance_rates'].admin_fee) }}</div>
                                                            </div>
                                                            <div class="table-view-detail" v-if="TrucksArr[trkey].tax != null">
                                                                <div class="left-section">Tax &nbsp; (5%) :</div>
                                                                <div class="right-section">$ {{ numberFormat(TrucksArr[trkey].tax) }}</div>
                                                            </div>

                                                            <template v-for="(charges,chargekey) in TrucksArr[trkey]['charges']">
                                                                <div :key="chargekey" class="table-view-detail">
                                                                    <div class="left-section">{{charges.chargeName}} :</div>
                                                                    <div class="right-section">$ {{ numberFormat(charges.amount)}}</div>
                                                                </div>
                                                            </template>
                                                            <div class="total-block" v-if="tData.total > 0">
                                                                <div class="section pull-left">
                                                                    Total :
                                                                </div>
                                                                <div class="section pull-right">
                                                                    $ {{ numberFormat(tData.total) }}
                                                                </div>
                                                            </div>
                                                            <div v-else class="total-block">
                                                                <div class="section">
                                                                    Charges Not Available
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="mt-4 mb-4" v-if="BookData.cancelled == 0 && tData.cancelled == 0">
                                                <a class="btn btn-primary" v-if="canAddExtraCharge" href="javascript:void(0)" v-on:click="openModal('')">+ Extra Charge</a>
                                            </div> -->
                                            <div v-if="TrucksArr[trkey]['charges'].length" class="table-responsive-sm">
                                                <table aria-describedby="table" class="table table-bordered table-sm">
                                                    <tr class="table-primary">
                                                        <th>Detail</th>
                                                        <th class="text-right">Amount</th>
                                                        <th>Documents</th>
                                                        <th class="action-field">Action</th>
                                                    </tr>
                                                    <template v-for="(charges,chargekey) in TrucksArr[trkey]['charges']">
                                                        <tr :key="chargekey">
                                                            <td>{{charges.chargeName}}</td>
                                                            <td class="text-right">$ {{numberFormat(charges.amount)}}</td>
                                                            <td>
                                                                <template v-for="(doc,docKey) in TrucksArr[trkey]['charges'][chargekey]['doc_path']">
                                                                    <a v-bind:key="docKey" v-on:click="viewChargesFile(charges.id,doc.url)" href="javascript:void(0)" class="color-blue" data-toggle="tooltip" title="View Document" v-if="doc != ''">{{doc.display_name}}</a>
                                                                    <span :key="docKey" v-if="docKey < TrucksArr[trkey]['charges'][chargekey]['doc_path'].length - 1">&nbsp; &nbsp; | &nbsp; &nbsp;</span>
                                                                </template>
                                                            </td>
                                                            <td>
                                                                <a href="javascript:void(0)" v-if="canUpdateExtraCharge" class="fp-edit" v-on:click="openModal(charges)" data-toggle="tooltip" title="Update Charges"></a>
                                                                    &nbsp;&nbsp; |&nbsp;&nbsp;
                                                                <a href="javascript:void(0)" v-if="canRemoveExtraCharge" class="fp-add rotate-45" v-on:click="removeField(charges.id)" data-toggle="tooltip" title="Remove Charges"></a>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </table>
                                            </div>
                                            <div class="insurance-deatils mt-4">
                                                <h4>Insurance</h4>
                                                <div class="insurance-block p-lg-4 p-3">                
                                                    <div class="list-sections">
                                                        <div class="form-row section-divider">
                                                            <div class="col-md-6">
                                                                <div class="form-group">
                                                                    <label class="">Customer Purchasing Insurance:</label>
                                                                    <span class="col"> {{ tData.customer_insured }} </span>
                                                                </div>
                                                                <template v-if="tData.customer_insured.toLowerCase() == 'yes'">
                                                                    <template v-if="tData.policy_type != ''">
                                                                        <div class="form-group">
                                                                            <label class="">Policy Type:</label>
                                                                            <span class="col"> {{ titleCase(tData.policy_type) }} </span>
                                                                        </div>
                                                                    </template>    
                                                                </template>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <template v-if="tData.customer_insured.toLowerCase() == 'yes'">
                                                                    <template v-if="tData.policy_type != ''">
                                                                        <div class="form-group">
                                                                            <label class="">Insurance From Date:</label>
                                                                            <template v-if="tData.policy_type == 'physical' || tData.policy_type == 'both'">
                                                                                <template v-if="tData.physical_from != undefined && tData.physical_from != null && tData.physical_from != ''">
                                                                                    <span class="col"> {{ tData.physical_from }} </span>
                                                                                </template>
                                                                                <template v-else>
                                                                                    <span class="col"> - </span>
                                                                                </template>        
                                                                            </template>
                                                                            <template v-else>
                                                                                <template v-if="tData.liability_from != undefined && tData.liability_from != null && tData.liability_from != ''">
                                                                                    <span class="col"> {{ tData.liability_from }} </span>
                                                                                </template>
                                                                                <template v-else>
                                                                                    <span class="col"> - </span>
                                                                                </template>
                                                                            </template>            
                                                                        </div>
                                                                        <div class="form-group">
                                                                            <label class="">Insurance To Date:</label>
                                                                            <template v-if="tData.policy_type == 'physical' || tData.policy_type == 'both'">
                                                                                <template v-if="tData.physical_to != undefined && tData.physical_to != null && tData.physical_to != ''">
                                                                                    <span class="col"> {{ tData.physical_to }} </span>
                                                                                </template>
                                                                                <template v-else>
                                                                                    <span class="col"> - </span>
                                                                                </template>
                                                                            </template>
                                                                            <template v-else>
                                                                                <template v-if="tData.liability_to != undefined && tData.liability_to != null && tData.liability_to != ''">
                                                                                    <span class="col"> {{ tData.liability_to }} </span>
                                                                                </template>
                                                                                <template v-else>
                                                                                    <span class="col"> - </span>
                                                                                </template>
                                                                            </template>
                                                                        </div>
                                                                    </template>          
                                                                </template>
                                                            </div>
                                                        </div>
                                                        <template v-if="tData.customer_insured.toLowerCase() == 'yes'">
                                                            <div class="form-group">
                                                                <label class="">Insurance Charges:</label>
                                                                <div class="table-responsive-sm">
                                                                    <table aria-describedby="table" class="table table-sm table-bordered">
                                                                        <thead>
                                                                            <tr class="table-primary">
                                                                                <th>Charge Name</th>
                                                                                <th>Days</th>
                                                                                <th class="text-right">Charge</th>
                                                                                <th class="text-right">Total</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <template v-if="TrucksArr[trkey]['insurance_charges_details'] && TrucksArr[trkey]['insurance_charges_details'].length > 0">
                                                                                <template v-for="(row, inchdex) in TrucksArr[trkey]['insurance_charges_details']">
                                                                                    <tr v-if="row.physical_ins_charges != undefined" :key="'physical_ins' + inchdex">
                                                                                        <td>{{row.phy_charges_name}}</td>
                                                                                        <td>{{row.days}} Days</td>
                                                                                        <td class="text-right">${{numberFormat(row.physical_ins_charges)}}</td>
                                                                                        <td class="text-right">${{numberFormat(row.physical_ins_total)}}</td>
                                                                                    </tr>

                                                                                    <tr v-if="row.physical_admin_charges != undefined" :key="'physical_admin' + inchdex">
                                                                                        <td>{{row.phy_admincharges_name}}</td>
                                                                                        <td>-</td>
                                                                                        <td class="text-right">${{numberFormat(row.physical_admin_charges)}}</td>
                                                                                        <td class="text-right">${{numberFormat(row.physical_admin_total)}}</td>
                                                                                    </tr>

                                                                                    <tr v-if="row.liability_insurance_charges != undefined" :key="'liability_ins' + inchdex">
                                                                                        <td>{{row.lia_insurance_name}}</td>
                                                                                        <td>{{row.days}} Days</td>
                                                                                        <td class="text-right">${{numberFormat(row.liability_insurance_charges)}}</td>
                                                                                        <td class="text-right">${{numberFormat(row.liability_insurance_total)}}</td>
                                                                                    </tr>

                                                                                    <tr v-if="row.liability_admin_charges != undefined" :key="'liability_admin' + inchdex">
                                                                                        <td>{{row.lia_admincharges_name}}</td>
                                                                                        <td>-</td>
                                                                                        <td class="text-right">${{numberFormat(row.liability_admin_charges)}}</td>
                                                                                        <td class="text-right">${{numberFormat(row.liability_admin_total)}}</td>
                                                                                    </tr>
                                                                                </template>
                                                                            </template>
                                                                            <template v-else>
                                                                                <tr><td colspan="4" class="text-center">No Insurance Charges Found.</td></tr>
                                                                            </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <label class="">Insurance Certificate:</label>
                                                                <div class="attachment-view-internal-section">
                                                                    <template v-if="TrucksArr[trkey]['insurance_certificates'].length > 0">
                                                                        <template v-for="(doc,vkey) in TrucksArr[trkey]['insurance_certificates']">
                                                                            <div v-bind:key="'fileDiv'+vkey" class="attachment-list">
                                                                                <i v-if="doc.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                                                <i v-if="doc.extension == 'doc' || doc.extension == 'docs'" class="fp-text-document"></i>
                                                                                <i v-if="doc.extension == 'jpg' ||  doc.extension == 'png' ||  doc.extension == 'jpeg' " class="fp-image"></i>
                                                                                <!-- <a :key="vkey" href="javascript:void(0)" class="customer-detail-rv" v-on:click="openDocument(doc.url,doc.extension)">  {{splitString(doc.file_name)}}</a> -->
                                                                                <a :key="vkey" href="javascript:void(0)" class="customer-detail-rv" v-on:click="openDocument(doc.url,doc.extension)">  {{doc.display_name}}</a>
                                                                            </div>
                                                                        </template>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span>No Insurance Certificate found.</span>
                                                                    </template>
                                                                </div>
                                                            </div>
                                                        </template>    
                                                        <div class="table-responsive-sm" v-if="tData.customer_insured != '-'">
                                                            <div class="form-group">
                                                                <label class="">Insurance Policy:</label>
                                                                <table aria-describedby="table" class="table table-sm table-bordered">
                                                                    <thead>
                                                                        <tr class="table-primary">
                                                                            <th>Policy Number</th>
                                                                            <th>Insurance Company</th>
                                                                            <th>Agent Name</th>
                                                                            <th>Agent Contact</th>
                                                                            <th>Status</th>
                                                                            <th>Start Date</th>
                                                                            <th>Expiry Date</th>
                                                                            <th>Blanket Policy</th>
                                                                            <th>Policy Type</th>
                                                                            <th>Self Insured For</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <template v-if="TrucksArr[trkey]['insurance_policy_details'] && TrucksArr[trkey]['insurance_policy_details'].length > 0">
                                                                            <template v-for="(row, index) in TrucksArr[trkey]['insurance_policy_details']">
                                                                                <tr v-bind:key="'insPolicy'+index">
                                                                                    <td>{{row.policy_number}}</td>
                                                                                    <td>{{row.insurance_company_name}}</td>
                                                                                    <td>{{row.agent_name}}</td>
                                                                                    <td>{{row.agent_contact}}</td>
                                                                                    <td>{{row.status}}</td>
                                                                                    <td>{{row.start_date}}</td>
                                                                                    <td>{{row.expiry_date}}</td>
                                                                                    <td v-if="row.is_rental_blanket == 1">Yes</td>
                                                                                    <td v-else>No</td>
                                                                                    <td>{{row.policy_type}}</td>
                                                                                    <td>{{row.self_insured_for}}</td>
                                                                                </tr>
                                                                            </template>
                                                                        </template>
                                                                        <template v-else>
                                                                            <tr><td colspan="10" class="text-center">No Insurance Policy Found.</td></tr>
                                                                        </template>
                                                                    </tbody>
                                                                </table>
                                                            </div>    
                                                        </div>
                                                    </div>
                                                    <!-- <div class="radio-selection border-bottom pb-2 mb-3">
                                                        <label class="mr-2">Physical & Liability Insurance: </label>
                                                        <div class="custome-radiobtn form-check-inline">
                                                            <div class="form-check form-check-inline">
                                                                <label class="boolean optional radio-custom" for="provide_ins"> Provide Insurance
                                                                    <input type="radio" disabled v-model="insuranceType" :value="1" name="is_default" id="provide_ins"> <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <div class="form-check form-check-inline">
                                                                <label id="depriciable2_item" class="boolean optional radio-custom" for="purchase_ins"> Purchase Insurance
                                                                    <input type="radio" disabled v-model="insuranceType"  :value="0" name="is_default" id="purchase_ins"> <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div> -->
                                                    <!-- <template v-if="phyfromTheir">
                                                        <div class="form-row row-cols-md-4 row-cols-1">
                                                            <div class="col form-group" v-if="comSelect">
                                                                <label class="control-label">Insurance Policies : </label>
                                                                <v-select placeholder="Select Insurance Policy" disabled v-model="insCompany" label="text" :options="companyArr"></v-select>
                                                            </div>
                                                            <div class="col form-group">
                                                                <label class="control-label require">Company Name : </label>
                                                                <v-select v-model="phyCompanyName" :searchable="phyCompanyDisabled" name="checkUser"
                                                                        label="text" :filterable="false" :options="AllcompanyArr"
                                                                        @search="onSearch" disabled
                                                                        placeholder="Select Insurance Company" class="custom-ci-auto-search">
                                                                    <template slot="no-options">
                                                                        Search Insurance Company...
                                                                    </template>
                                                                    <template slot="option" slot-scope="option">
                                                                        <div class="d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                    <template slot="selected-option" slot-scope="option">
                                                                        <div class="selected d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                </v-select>
                                                                <div class="field-error" >{{ phycompanyerrors }}</div>
                                                            </div>
                                                            <div class="col form-group">
                                                                <label class="control-label require">Contact Number : </label>
                                                                <input v-model.trim="phyContactNo" class="form-control ins" disabled name="ContactNumber" type="text"
                                                                                            placeholder="Contact Number">
                                                                <div class="field-error" >{{ phynumbererrors }}</div>
                                                            </div>
                                                            <div class="col form-group">
                                                                <label class="control-label">Contact Name : </label>
                                                                 <input v-model.trim="phyContactName" class="form-control ins" disabled name="ContactNumber" type="text"
                                                                                                placeholder="Contact Name">
                                                                <div class="field-error" >{{ phycontacterror }}</div>
                                                            </div>
                                                            <div class="col form-group">
                                                                <label class="control-label">Email : </label>
                                                                <input v-model.trim="phyEmail" class="form-control ins" disabled name="ContactNumber" type="text"
                                                                                            placeholder="Contact Email">
                                                                <div class="field-error" >{{ phyemailerrors }}</div>
                                                            </div>
                                                            <div class="col form-group">
                                                                <label class="control-label">Policy Number : </label>
                                                                <input v-model.trim="phyPolicyNo" class="form-control ins" disabled name="Policy" type="text"
                                                                                                placeholder="Policy Number">
                                                                <div class="field-error" >{{ phypolicyerrors }}</div>
                                                            </div>
                                                        </div>
                                                        <div class="form-row">
                                                            <div class="col">
                                                                <div class="document-upload tab-section">
                                                                    <label class="pb-2 mb-3">Documents :</label>
                                                                    <template v-if="TrucksArr[trkey]['phyinsfiles'][0]">
                                                                        <template v-if="TrucksArr[trkey]['phyinsfiles'][0]['from_their']">
                                                                            <div class="row row-cols-md-6 row-cols-1">
                                                                                <template v-for="(fileinsData, fileskey) in TrucksArr[trkey]['phyinsfiles'][0]['from_their']">
                                                                                    <div class="col" :key="'phyinsfiles'+fileskey" v-if="fileinsData.name != ''">
                                                                                        <div class="thumbnail-inspection-img">
                                                                                            <a href="javascript:void(0)" v-if="fileinsData.extension == 'doc'">
                                                                                                <iframe :src="'https://docs.google.com/viewer?embedded=true&url='+fileinsData.url"  title="" width="150px;" height='150px;'></iframe>
                                                                                            </a>
                                                                                            <a href="javascript:void(0)"  v-on:click="viewFile(fileinsData.id,fileinsData.url,'from_their')" v-else>
                                                                                                <img :src="fileinsData.url" :alt="fileinsData.display_name" width="150px;" height='150px;'/>
                                                                                            </a>
                                                                                            <i v-on:click="deleteInsuranceFile(fileinsData.id, tData.reservationId, tData.id)" class="fp-add rotate-45" aria-hidden="true" ></i>
                                                                                        </div>
                                                                                    </div>
                                                                                </template>
                                                                            </div>
                                                                        </template>
                                                                        <template v-else>
                                                                            <span class='display-block mb-3'>No Data Found.</span>
                                                                        </template>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span class='display-block mb-3'>No Data Found.</span>
                                                                    </template>
                                                                </div>
                                                            </div>
                                                        </div> -->
                                                        <!-- <div class="btn-groups">
                                                            <div class="custom-upload-container ml-0" data-provides="fileupload" v-if="phyDocumentShow">
                                                                <label for="physicalFiles" class="btn btn-secondary mb-0"> <i class="fp-upload"> </i> Upload</label>
                                                                <label for="physicalFiles" class="hide btn btn-secondary">Change</label>
                                                                <input class="hide" type="file" id="physicalFiles" ref="phyFiles" multiple v-on:change="handleinsFilesUpload('physical')"/>
                                                            </div>
                                                            <a class="btn btn-primary" href="javascript:void(0)" v-on:click="submitFiles(0,'from_their',tData.reservationId,tData.id,tData.pickup_date,tData.dropoff_date)">
                                                                <i class="fp-submit"> </i> Submit
                                                            </a>
                                                        </div>
                                                        <template v-if="phyDocumentShow">
                                                            <div class="form-row row-cols-md-4 row-cols-1">
                                                                <template v-for="(file, key) in insfile">
                                                                    <div v-bind:key="key" class="file-container col" :id="'fileDiv'+file.id">
                                                                        <span class="fileupload-preview">{{ file.name }}</span>
                                                                        <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteInsuranceDoc(file.id,key,'physical')" style="float: right">
                                                                            <i class="fp-remove"></i>
                                                                        </a>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </template>
                                                        <span class="field-error">{{ phyDocerrors }}</span> -->
                                                    <!-- </template>
                                                    <template v-if="!phyfromTheir" >
                                                        <div class="document-upload">
                                                            <div class="tab-section">
                                                                <template  v-if="insuranceRates['phy_ins_charge'].length > 0 || insuranceRates['lia_ins_charge'].length > 0 || insuranceRates['admin_fee'] > 0">
                                                                    <label class="control-label pb-2 mb-3" for="charges_title" >Charges:</label>
                                                                        <div class="table-responsive">
                                                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                                                <thead>
                                                                                    <tr class="table-primary">
                                                                                        <th scope="col" style="width:400px;">Charge Name</th>
                                                                                        <th scope="col">Days</th>
                                                                                        <th scope="col">Charge</th>
                                                                                        <th scope="col">Total</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                <template v-for="(row, index) in insuranceRates">
                                                                                    <tr v-if="index=='phy_ins_charge' && row!=''" :key="index">
                                                                                        <td scope="col">Physical Insurance :</td>
                                                                                        <td scope="col">{{row['days']}} Days</td>
                                                                                        <td scope="col">${{numberFormat(row['rate'])}}</td>
                                                                                        <td scope="col">${{numberFormat(row['total'])}}</td>
                                                                                    </tr>
                                                                                    <tr v-if="index=='lia_ins_charge' && row!=''">
                                                                                        <td scope="col">Liability Insurance :</td>
                                                                                        <td scope="col">{{row['days']}} Days</td>
                                                                                        <td scope="col">${{numberFormat(row['rate'])}}</td>
                                                                                        <td scope="col">${{numberFormat(row['total'])}}</td>
                                                                                    </tr>
                                                                                    <tr v-if="index=='admin_fee' && row > 0">
                                                                                        <td scope="col">Admin Fee:</td>
                                                                                        <td scope="col">-</td>
                                                                                        <td scope="col">-</td>
                                                                                        <td scope="col">${{numberFormat(row)}}</td>
                                                                                    </tr>
                                                                                </template>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    <span class='noInsFile'>No Charges found.</span>
                                                                </template> -->
                                                                <!-- <template v-if="TrucksArr[trkey]['phyinsfiles'] && TrucksArr[trkey]['phyinsfiles'][0] && TrucksArr[trkey]['phyinsfiles'][0]['from_us']">
                                                                    <div class="row row-cols-md-6 row-cols-1">
                                                                        <template v-for="(fileinsData, fileskey) in TrucksArr[trkey]['phyinsfiles'][0]['from_us']">
                                                                            <div class="col" :key="'insrFromUsFile'+fileskey" v-if="fileinsData.display_name != ''">
                                                                                <div class="thumbnail-inspection-img">
                                                                                    <a href="javascript:void(0)" v-if="fileinsData.extension == 'doc'">
                                                                                        <iframe :src="'https://docs.google.com/viewer?embedded=true&url='+fileinsData.url" title="" width="150px;" height='150px;'></iframe>
                                                                                    </a>
                                                                                    <a href="javascript:void(0)" v-on:click="viewFile(fileinsData.id,fileinsData.url,'from_us')" v-else>
                                                                                        <img :src="fileinsData.url" :alt="fileinsData.display_name" width="170px;" height='150px;'/>
                                                                                    </a>
                                                                                    <i v-on:click="deleteInsuranceFile(fileinsData.id, tData.reservationId, tData.id )" class="fp-add rotate-45" aria-hidden="true" ></i>
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    <span class='display-block mb-3'>No document found.</span>
                                                                </template> -->
                                                            <!-- </div> -->
                                                            <!-- <div class="btn-groups">
                                                                <div class="custom-upload-container ml-0" data-provides="fileupload">
                                                                    <label for="documentsUpload" class="btn btn-secondary"> <i class="fp-upload"> </i> Upload</label>
                                                                    <input class="hide" id="documentsUpload" type="file" @change="handleDocUpload" multiple>
                                                                </div>
                                                                <a class="btn btn-primary" href="javascript:void(0)" v-on:click="submitFiles(0,'from_us',tData.reservationId,tData.id,tData.pickup_date,tData.dropoff_date)">
                                                                    <i class="fp-submit"> </i> Submit
                                                                </a>
                                                            </div>
                                                            <div class="form-row row-cols-md-4 row-cols-1">
                                                                <template v-for="(file, filekey) in selectedFile">
                                                                    <div v-bind:key="filekey" class="file-container col" :id="'fileDiv'+file.id">
                                                                        <span class="fileupload-preview">{{ file.name }}</span>
                                                                        <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteFromUsDoc(filekey)" style="float: right">
                                                                            <i class="fp-remove"></i>
                                                                        </a>
                                                                    </div>
                                                                </template>
                                                                <div class="field-error">{{ insDocerrors }}</div>
                                                            </div> -->
                                                        <!-- </div>
                                                    </template> -->
                                                </div>
                                            </div>
                                            <!-- <div class="inspection-deatils mt-4">
                                                <div class="overflow-hidden">
                                                    <h4 class="pull-left">Inspection</h4>
                                                    <button id="syncInspBtn" type="button" class="btn btn-primary pull-right" v-on:click="SyncInspectionData(tData.reservationId,tData.id)">
                                                        <i class="fp-text-document"></i> Sync Inspection
                                                    </button>
                                                </div>
                                                <div class="tab-inspection-block mt-3">
                                                    <h5>Inspection At Pick Up </h5>
                                                    <div class="inspection-container">
                                                        <template v-if="pickUpArr.length > 0">
                                                            <div class="row row-cols-md-4 row-cols-1">
                                                                <div class="col form-group">
                                                                    <label>Unit No : </label>
                                                                    <span>{{pickUpArr.unit_number}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Customer Name : </label>
                                                                    <span>{{pickUpArr.customer_name}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Customer Email : </label>
                                                                    <span>{{pickUpArr.cust_email}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Customer Address : </label>
                                                                    <span>{{pickUpArr.customer_address}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Contract No : </label>
                                                                    <span>{{pickUpArr.contract_no}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Date of Birth : </label>
                                                                    <sapn v-if="pickUpArr.customer_dob != null">{{pickUpArr.customer_dob}}</sapn>
                                                                    <sapn v-else>{{"-"}}</sapn>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Driver Licence Exp Date : </label>
                                                                    <sapn v-if="pickUpArr.customer_dob != null">{{pickUpArr.driver_licence_exp_date}}</sapn>
                                                                    <sapn v-else>{{"-"}}</sapn>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Mileage In : </label>
                                                                    <span>{{pickUpArr.mileage_in}}</span>
                                                                </div>
                                                                <div class="clearfix"></div>
                                                                <div class="col form-group">
                                                                    <label>Mileage Out : </label>
                                                                    <span>{{pickUpArr.mileage_out}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Refer Hour In : </label>
                                                                    <span>{{pickUpArr.refer_hour_in}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Refer Hour Out : </label>
                                                                    <span>{{pickUpArr.refer_hour_out}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Fuel Level : </label>
                                                                    <span>{{pickUpArr.fuel_level}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Def Level : </label>
                                                                    <span>{{pickUpArr.def_level}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Inspection By : </label>
                                                                    <span>{{pickUpArr.inspection_by}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Created Date : </label>
                                                                    <span>{{pickUpArr.created_at}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Recored Created Date : </label>
                                                                    <span>{{pickUpArr.record_created_at}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>E-mail Send To : </label>
                                                                    <span>{{pickUpArr.email_sent_to}}</span>
                                                                </div>
                                                            </div>
                                                            <div class="row mt-3">
                                                                <div class="col">
                                                                    <div class="label-left">Check List: </div>
                                                                    <div class="inspection-check-list" v-if="pickUpArr.check_list['Current Registration'] === 'True'">
                                                                        <img src="/static/images/green-tick.png" width="15">
                                                                        <p class="mb-0"> Current Registration</p>
                                                                    </div>
                                                                    <div class="inspection-check-list" v-else>
                                                                        <img src="/static/images/gray-tick.png" width="15">
                                                                        <p class="mb-0"> Current Registration </p>
                                                                    </div>

                                                                    <div class="inspection-check-list" v-if="pickUpArr.check_list['Fire Extinguisher'] === 'True'">
                                                                        <img src="/static/images/green-tick.png" width="15">
                                                                        <p class="mb-0"> Fire Extinguisher</p>
                                                                    </div>
                                                                    <div class="inspection-check-list" v-else>
                                                                        <img src="/static/images/gray-tick.png" width="15">
                                                                        <p class="mb-0"> Fire Extinguisher </p>
                                                                    </div>

                                                                    <div class="inspection-check-list" v-if="pickUpArr.check_list['Trip Reports Explained'] === 'True'">
                                                                        <img src="/static/images/green-tick.png" width="15">
                                                                        <p class="mb-0"> Trip Reports Explained</p>
                                                                    </div>
                                                                    <div class="inspection-check-list" v-else>
                                                                        <img src="/static/images/gray-tick.png" width="15">
                                                                        <p class="mb-0"> Trip Reports Explained </p>
                                                                    </div>

                                                                    <div class="inspection-check-list" v-if="pickUpArr.check_list['Regeneration Explained'] === 'True'">
                                                                        <img src="/static/images/green-tick.png" width="15">
                                                                        <p class="mb-0"> Regeneration Explained</p>
                                                                    </div>
                                                                    <div class="inspection-check-list" v-else>
                                                                        <img src="/static/images/gray-tick.png" width="15">
                                                                        <p class="mb-0"> Regeneration Explained </p>
                                                                    </div>

                                                                    <div class="inspection-check-list" v-if="pickUpArr.check_list['Checked PM'+'s'] === 'True'">
                                                                        <img src="/static/images/green-tick.png" width="15">
                                                                        <p class="mb-0"> Checked PM's</p>
                                                                    </div>
                                                                    <div class="inspection-check-list" v-else>
                                                                        <img src="/static/images/gray-tick.png" width="15">
                                                                        <p class="mb-0"> Checked PM's </p>
                                                                    </div>

                                                                    <div class="inspection-check-list" v-if="pickUpArr.check_list['Free of smoke odor'] === 'True'">
                                                                        <img src="/static/images/green-tick.png" width="15">
                                                                        <p class="mb-0"> Free of smoke odor</p>
                                                                    </div>
                                                                    <div class="inspection-check-list" v-else>
                                                                        <img src="/static/images/gray-tick.png" width="15">
                                                                        <p class="mb-0"> Free of smoke odor </p>
                                                                    </div>

                                                                    <div class="inspection-check-list" v-if="pickUpArr.check_list['ELD Explained'] === 'True'">
                                                                        <img src="/static/images/green-tick.png" width="15">
                                                                        <p class="mb-0"> ELD Explained</p>
                                                                    </div>
                                                                    <div class="inspection-check-list" v-else>
                                                                        <img src="/static/images/gray-tick.png" width="15">
                                                                        <p class="mb-0"> ELD Explained </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mt-3">
                                                                <div class="col">
                                                                    <span class="">Photos : </span>
                                                                    <template v-if="pickUpArr.length > 0">
                                                                        <div class="row row-cols-md-6 row-cols-1">
                                                                            <template v-for="(data, ikey) in pickUpArr.photoes">
                                                                                <div class="col" :key="'pickUp'+ikey" v-if="data.type == 'photo'">
                                                                                    <figure class="effect-ming">
                                                                                        <div class="thumbnail-inspection-img">
                                                                                            <a href="javascript:void(0)">
                                                                                                <img :src="data.thumbUrl" :alt="data.inspectionfiles"/>
                                                                                            </a>
                                                                                        </div>
                                                                                        <figcaption v-on:click="viewInspectionFile(data.url, data.inspectionfiles)">
                                                                                            <h2>{{ data.inspectionfiles }}</h2>
                                                                                        </figcaption>
                                                                                    </figure>
                                                                                </div>
                                                                            </template>
                                                                        </div>
                                                                    </template>
                                                                    <template v-else>
                                                                        <div class='mb-3'>
                                                                            No Data Found
                                                                        </div>
                                                                    </template>
                                                                </div>
                                                            </div>
                                                            <div class="row mt-3">
                                                                <div class="col">
                                                                    <span class="">Signature : </span>
                                                                    <template v-if="pickUpArr.length > 0">
                                                                        <div class="row row-cols-md-6 row-cols-1">
                                                                            <template v-for="(data, sikey) in pickUpArr.signs">
                                                                                <div class="col" :key="'pickUp'+sikey" v-if="data.type != 'photo'">
                                                                                    <figure class="effect-ming">
                                                                                        <div class="thumbnail-inspection-img">
                                                                                            <a href="javascript:void(0)">
                                                                                                <img :src="data.url" :alt="data.inspectionfiles"/>
                                                                                            </a>
                                                                                        </div>
                                                                                        <figcaption v-on:click="viewInspectionFile(data.url, data.inspectionfiles)">
                                                                                            <h2>{{ data.inspectionfiles }}</h2>
                                                                                        </figcaption>
                                                                                    </figure>
                                                                                </div>
                                                                            </template>
                                                                        </div>
                                                                    </template>
                                                                    <template v-else>
                                                                        <div class='mb-3'>
                                                                            No Data Found
                                                                        </div>
                                                                    </template>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class='mb-3'>
                                                                No Data Found
                                                            </div>
                                                        </template>
                                                    </div>
                                                </div>
                                                <div class="tab-inspection-block mt-3">
                                                    <h5>Inspection At Drop Off </h5>
                                                    <div class="inspection-container">
                                                        <template v-if="dropOffData.length > 0">
                                                            <div class="row row-cols-md-4 row-cols-1">
                                                                <div class="col form-group">
                                                                    <label>Unit No : </label>
                                                                    <span>{{dropOffData.unit_number}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Customer Name : </label>
                                                                    <span>{{dropOffData.customer_name}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Customer Email : </label>
                                                                    <span>{{dropOffData.cust_email}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Customer Address : </label>
                                                                    <span>{{dropOffData.customer_address}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Contract No : </label>
                                                                    <span>{{dropOffData.contract_no}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Date of Birth : </label>
                                                                    <sapn v-if="dropOffData.customer_dob != null">{{dropOffData.customer_dob}}</sapn>
                                                                    <sapn v-else>{{"-"}}</sapn>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Driver Licence Exp Date : </label>
                                                                    <sapn v-if="dropOffData.customer_dob != null">{{dropOffData.driver_licence_exp_date}}</sapn>
                                                                    <sapn v-else>{{"-"}}</sapn>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Mileage In : </label>
                                                                    <span>{{dropOffData.mileage_in}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Mileage Out : </label>
                                                                    <span>{{dropOffData.mileage_out}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Refer Hour In : </label>
                                                                    <span>{{dropOffData.refer_hour_in}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Refer Hour Out : </label>
                                                                    <span>{{dropOffData.refer_hour_out}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Fuel Level : </label>
                                                                    <span>{{dropOffData.fuel_level}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Def Level : </label>
                                                                    <span>{{dropOffData.def_level}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Inspection By : </label>
                                                                    <span>{{dropOffData.inspection_by}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Created Date : </label>
                                                                    <span>{{dropOffData.created_at}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>Recored Created Date : </label>
                                                                    <span>{{dropOffData.record_created_at}}</span>
                                                                </div>
                                                                <div class="col form-group">
                                                                    <label>E-mail Send To : </label>
                                                                    <span>{{dropOffData.email_sent_to}}</span>
                                                                </div>
                                                            </div>
                                                            <div class="row mt-3">
                                                                <div class="col">
                                                                    <div class="label-left">Check List: </div>
                                                                    <div class="inspection-check-list" v-if="dropOffData.check_list['Current Registration'] === 'True'">
                                                                        <img src="/static/images/green-tick.png" width="15">
                                                                        <p class="mb-0"> Current Registration</p>
                                                                    </div>
                                                                    <div class="inspection-check-list" v-else>
                                                                        <img src="/static/images/gray-tick.png" width="15">
                                                                        <p class="mb-0"> Current Registration </p>
                                                                    </div>

                                                                    <div class="inspection-check-list" v-if="dropOffData.check_list['Fire Extinguisher'] === 'True'">
                                                                        <img src="/static/images/green-tick.png" width="15">
                                                                        <p class="mb-0"> Fire Extinguisher</p>
                                                                    </div>
                                                                    <div class="inspection-check-list" v-else>
                                                                        <img src="/static/images/gray-tick.png" width="15">
                                                                        <p class="mb-0"> Fire Extinguisher </p>
                                                                    </div>

                                                                    <div class="inspection-check-list" v-if="dropOffData.check_list['Trip Reports Explained'] === 'True'">
                                                                        <img src="/static/images/green-tick.png" width="15">
                                                                        <p class="mb-0"> Trip Reports Explained</p>
                                                                    </div>
                                                                    <div class="inspection-check-list" v-else>
                                                                        <img src="/static/images/gray-tick.png" width="15">
                                                                        <p class="mb-0"> Trip Reports Explained </p>
                                                                    </div>

                                                                    <div class="inspection-check-list" v-if="dropOffData.check_list['Regeneration Explained'] === 'True'">
                                                                        <img src="/static/images/green-tick.png" width="15">
                                                                        <p class="mb-0"> Regeneration Explained</p>
                                                                    </div>
                                                                    <div class="inspection-check-list" v-else>
                                                                        <img src="/static/images/gray-tick.png" width="15">
                                                                        <p class="mb-0"> Regeneration Explained </p>
                                                                    </div>

                                                                    <div class="inspection-check-list" v-if="dropOffData.check_list['Checked PM'+'s'] === 'True'">
                                                                        <img src="/static/images/green-tick.png" width="15">
                                                                        <p class="mb-0"> Checked PM's</p>
                                                                    </div>
                                                                    <div class="inspection-check-list" v-else>
                                                                        <img src="/static/images/gray-tick.png" width="15">
                                                                        <p class="mb-0"> Checked PM's </p>
                                                                    </div>

                                                                    <div class="inspection-check-list" v-if="dropOffData.check_list['Free of smoke odor'] === 'True'">
                                                                        <img src="/static/images/green-tick.png" width="15">
                                                                        <p class="mb-0"> Free of smoke odor</p>
                                                                    </div>
                                                                    <div class="inspection-check-list" v-else>
                                                                        <img src="/static/images/gray-tick.png" width="15">
                                                                        <p class="mb-0"> Free of smoke odor </p>
                                                                    </div>

                                                                    <div class="inspection-check-list" v-if="dropOffData.check_list['ELD Explained'] === 'True'">
                                                                        <img src="/static/images/green-tick.png" width="15">
                                                                        <p class="mb-0"> ELD Explained</p>
                                                                    </div>
                                                                    <div class="inspection-check-list" v-else>
                                                                        <img src="/static/images/gray-tick.png" width="15">
                                                                        <p class="mb-0"> ELD Explained </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mt-3">
                                                                <div class="col">
                                                                    <label>Photos : </label>
                                                                    <template v-if="dropOffData.photoes != ''">
                                                                        <div class="row row-cols-md-6 row-cols-1">
                                                                            <template v-for="(data, dkey) in dropOffData.photoes">
                                                                                <div class="col" :key="'pickUp'+dkey" v-if="data.type == 'photo'">
                                                                                    <figure class="effect-ming">
                                                                                        <div class="thumbnail-inspection-img">
                                                                                            <a href="javascript:void(0)">
                                                                                                <img :src="data.thumbUrl" :alt="data.inspectionfiles"/>
                                                                                            </a>
                                                                                        </div>
                                                                                        <figcaption v-on:click="viewInspectionFile(data.url, data.inspectionfiles)">
                                                                                            <h2>{{ data.inspectionfiles }}</h2>
                                                                                        </figcaption>
                                                                                    </figure>
                                                                                </div>
                                                                            </template>
                                                                        </div>
                                                                    </template>
                                                                    <template v-else>
                                                                        <div class='mb-3'>
                                                                            No Data Found
                                                                        </div>
                                                                    </template>
                                                                </div>
                                                            </div>
                                                            <div class="row mt-3">
                                                                <div class="col">
                                                                    <label>Signature : </label>
                                                                    <template v-if="dropOffData.signs != ''">
                                                                        <div class="row row-cols-md-6 row-cols-1">
                                                                            <template v-for="(data, lkey) in dropOffData.signs">
                                                                                <div class="col" :key="'pickUp'+lkey" v-if="data.type != 'photo'">
                                                                                    <figure class="effect-ming">
                                                                                        <div class="thumbnail-inspection-img">
                                                                                            <a href="javascript:void(0)">
                                                                                                <img :src="data.url" :alt="data.inspectionfiles"/>
                                                                                            </a>
                                                                                        </div>
                                                                                        <figcaption v-on:click="viewInspectionFile(data.url, data.inspectionfiles)">
                                                                                            <h2>{{ data.inspectionfiles }}</h2>
                                                                                        </figcaption>
                                                                                    </figure>
                                                                                </div>
                                                                            </template>
                                                                        </div>
                                                                    </template>
                                                                    <template v-else>
                                                                        <div class='mb-3'>
                                                                            No Data Found
                                                                        </div>
                                                                    </template>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class='mb-3'>
                                                                No Data Found
                                                            </div>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div> -->
                                            <div class="row" v-if="warningReservation">
                                                <div class="col">
                                                    <div class="alert alert-danger" id="alertWarning">
                                                        <strong>Vehicle  Already Reserved , Please Update The Reservation.</strong>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="grand-total">
                                                {{amtType}} Amount : <strong>${{ numberFormat(tData.total) }}</strong>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="!hideCompleteReservationBtn && RentedTrucksArr.length > 0">
                                        <span class="field-error" v-if="RentedTrucksArr[0].customerStage == 'Potential' || RentedTrucksArr[0].customerStage == 'Account Pending' || RentedTrucksArr[0].customerStage == 'Credit Denied'">Customer credit has not been approved.</span>
                                        <br>
                                    </template>
                                    <div class="btn-groups">
                                        <button v-if="!hideCompleteReservationBtn && ( RentedTrucksArr[0].customerStage == 'Potential' || RentedTrucksArr[0].customerStage == 'Account Pending' || RentedTrucksArr[0].customerStage == 'Credit Denied' )" type="button" class="btn btn-primary" v-on:click="confirmCompleteReservation()">
                                            <i class="fp-rental"></i> Complete Reservation
                                        </button>
                                        <button v-else-if="!hideCompleteReservationBtn" type="button" class="btn btn-primary" v-on:click="completeReservation()">
                                            <i class="fp-rental"></i> Complete Reservation
                                        </button>
                                    </div>
                                </div>
                            </template>
                            <div class="modal fade add-extra-charge-popup" id="extraChargeModal" ref="extraChargeModal" data-backdrop="static" data-keyboard="false" aria-labelledby="extraChargeModal" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title" id="myModal1">{{modalbtn}} Extra Charge</h5>
                                        </div>
                                        <div class="modal-body">
                                            <form id="SelectDates">
                                                <div class="form-row row-cols-md-2 row-cols-1">
                                                    <div  class="col form-group">
                                                        <label class="control-label">Detail:</label>
                                                        <v-select v-model="chargesDetails" :options="extraChargesArr" label="text" name="chargesDetails"
                                                            placeholder="Detail" id="Details" class="custom-vselect" @change="getChargeName(chargesDetails)">
                                                        </v-select>
                                                        <span class="field-error">{{errorDetails}}</span>
                                                    </div>
                                                    <div class="col form-group">
                                                        <label class="control-label">Amount:</label>
                                                        <input v-model="chargeAmt" name="chargeAmt" type="text" placeholder="Amount" id="chargeAmt" class="form-control">
                                                        <span class="field-error">{{errorChargeAmt}}</span>
                                                    </div>
                                                </div>
                                                <div class="form-row row-cols-md-2 row-cols-1">
                                                    <div class="col form-group">
                                                        <div class="custom-upload-container ml-0">
                                                            <label for="chargesFiles" class="btn btn-secondary"> <i class="fp-upload"></i> {{uploadBtn}}</label>
                                                            <label for="chargesFiles" class="btn btn-secondary hide"> <i class="fp-change"></i> Change</label>
                                                            <input class="hide" type="file" id="chargesFiles" ref="files" accept="image/*" v-on:change="handleFilesUpload()"/>
                                                        </div>
                                                        <template v-for="(file, fkey) in files">
                                                            <div v-bind:key="'chrFile'+fkey" class="file-container" :id="'fileDiv'+file.id" v-if="file.display_name != ''">
                                                                <span class="fileupload-preview">{{ file.display_name }}</span>
                                                                <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteChargesFile(fkey,file.id,chargeId,file.file_name)" style="float: right">
                                                                    <i class="fp-delete"></i>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <template v-for="(files, key1) in filesArr">
                                                            <div v-bind:key="key1" class="file-container" :id="'fileDiv'+files.id" v-if="files.name != ''">
                                                                <span class="fileupload-preview wrappath">{{ files.name }}</span>
                                                                <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteChargesFile(key1,files.id,chargeId,files.name)" style="float: right">
                                                                    <i class="fp-delete"></i>
                                                                </a>
                                                            </div>
                                                        </template>
                                                        <div class="field-error" id="fileerror">{{fileerroor_msg}}</div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div class="modal-footer btn-groups text-right">
                                            <button type="button" class="btn btn-tertiary" data-dismiss="modal" v-on:click="filesArr = []">
                                                <i class="fp-close"></i> Cancel
                                            </button>
                                            <button class="btn btn-primary" id="updateChargeBtn" v-on:click="updateFuelCharges(chargeId)">
                                                <i class="fp-submit"></i> Submit
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="modal fade invoice-modal" id="pre_auth_amount_modal" ref="preAuthAmount" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Update Pre-Auth Amount</h5>
                                        </div>
                                        <div class="modal-body">
                                            <form id="SelectDates" class="form-inline addinspectionForm">
                                                <div class="form-row">
                                                    <input type="hidden" v-model="bookingId">
                                                    <input type="hidden" v-model="truckId">
                                                    <div class="col form-group">
                                                        <input v-model="authCharges" name="pre_auth_amount" type="text"
                                                            placeholder="Pre-auth Amount" id="pre_auth_amount" class="form-control text-right">
                                                        <span class="field-error">Pre-auth amount can't be less than the grand total.</span>
                                                        <span class="field-error">{{error}}</span>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div class="modal-footer">
                                            <button class="btn btn-primary" id="myButton" v-on:click="addPreAuthCharges()"> <i class="fp-submit"> </i> Submit</button>
                                            <button type="button" class="btn btn-tertiary" data-dismiss="modal"> <i class="fp-close"> </i> Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade invoice-modal" id="invoice_modal" ref="invModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Invoice</h5>
                                        </div>
                                        <div class="modal-body">

                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-tertiary" data-dismiss="modal">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade invoice-modal" id="payCurrentAmount" ref="payCurrentAmount" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Summary</h5>
                                        </div>
                                        <div class="modal-body">
                                            <form id="SelectDates pay-amnt-rt" class="form-inline addinspectionForm">
                                                <div class="form-row row-cols-md-2 row-cols-1">
                                                    <div class="col form-group">
                                                        <label>Outstanding Amount:</label>
                                                        <span>${{outstandingAmt}}</span>
                                                    </div>
                                                    <div class="col form-group">
                                                        <label>Current Reservation Amount:</label>
                                                        <span>${{currentReservationAmt}}</span>
                                                    </div>
                                                    <div class="col form-group">
                                                        <label>Amount To Pay:</label>
                                                        <input v-model="amounttopay" name="amounttopay" type="text"
                                                            placeholder="Amount To Pay" id="amounttopay" class="form-control text-right">
                                                        <span class="field-error">{{pay_error}}</span>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div class="modal-footer">
                                            <button class="btn btn-primary" id="myButton" v-on:click="paymentProcess()">Pay</button>
                                            <button type="button" class="btn btn-tertiary" data-dismiss="modal">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import {commonMixins} from '../../mixins/commonMixins';

    export default {
        name: "viewBooking",
        metaInfo() {
            return {
                title: "Reservation Preview | " +process.env.COPYRIGHT_NAME
            }
        },
        mixins:[commonMixins],
        data: () => ({
            pickUpArr: [],
            dropOffData: [],
            readingOut:"",
            reading_out_msg:"",
            outstandingAmt:"",
            currentReservationAmt:"",
            amounttopay:"",
            amtType:"Estimated",
            readingIn:"",
            fromTheir:"",
            readingToken:false,
            phyfromTheir:"",
            insDocToken:false,
            reading_in_msg:"",
            enrichTransNoSpan:true,
            enrichTransNoText:"",
            enrichRefNo:"",
            viewEnrichInput:false,
            editEnrichInput:true,
            editStatusInput:true,
            viewStatusInput:false,
            enrichStatusSpan:true,
            view_booking_id: 0,
            CurrentStatus:"",
            // statusArr:[],
            liaOptions:[{value:'from_their',text:'Having Third Party Insurance' },{
                value:'from_us',text:'Do Not Have Third Party Insurance'
            }],
            bookingData: "",
            fix_rate: "",
            model: "",
            calculate:false,
            submitBtn : false,
            errorDetails:"",
            manufacturer: "",
            chargeId:0,
            miles: "",
            contact:"",
            doc_path:"",
            uploadBtn:'Upload',
            authCharges:"",
            authToken:false,
            rate: "",
            errorChargeAmt:"",
            RentedTrucksArr:[],
            TrucksArr:[],
            gallons:"",
            fuelRate:"",
            path:"",
            Invoicefile:"",
            invoiceDownPath:"",
            // fileData:{
            //   insuranceType:"",
            // },
            rateName: "",
            invoicePath:"",
            chargesfield :{
                id:0,
                othCharges:"",
                chargesDetails:"",

            },
            chargesFields : [],
            rateType: "",
            bookingId:"",
            doc_fileArr:[],
            fileerroor_msg:"",
            errorgallonsCharges:"",
            truckId:"",
            role:"",
            files:[],
            total: "",

            phyCompanyDisabled:true,
            phyContactDisabled:0,
            phyContactNameDisabled:0,
            phyEmailDisabled:0,
            phyPolicyNoDisabled:0,
            phyDocumentShow:true,

            phynumbererrors:"",
            phycompanyerrors:"",
            phyemailerrors:"",
            phycontacterror:"",
            phyDocerrors:"",
            insDocerrors: "",
            phypolicyerrors:"",

            phyCompanyName: "",
            phyContactNo: "",
            phyPolicyNo:"",
            liaPolicyNo:"",
            phyFiles: [],
            pay_error:"",
            editphyCompanyName:true,
            viewEditComForm:false,
            physcompanyName:"",
            editphyContactNum:true,
            viewEditContactForm:"",
            contactNum:"",
            editliaCompanyName:true,
            viewEditliaCompanyForm:false,
            editliaContactNum:true,
            viewliaEditContactForm:false,
            instype:"",
            errors: [],
            modalbtn:"Add",
            error:"",
            errorfuelCharges:"",
            updatefuelcharge:"",
            fuelcharge:"",
            pickupdate: "",
            loading:false,
            insfile:[],
            liafile:null,
            selectedFile:[],
            dropoffdate: "",
            fuelTotal:0,
            chargeAmt:"",
            truckPath:"",
            chargesDetails:"",
            loggedInUser:"",
            refError:"",
            statusErr:"",
            permissions:[],
            cantAccessPage: "",
            phyContactName:"",
            phyEmail:"",
            insCompany:[],
            checkTruckArr:[],
            checkArr:[],
            companyArr:[{value:"",text:"Select Insurance Company"}],
            canPay:false,
            comSelect:true,
            AllcompanyArr:[],
            insuranceType:"",
            basePath:"",
            filesArr:[],
            reservationId: '',
            hideUpdateCurrentStatus:false,
            canCancelReservation:false,
            canUpdateReservation:false,
            extraChargesArr:[],
            currentDate:'',
            canUpdateExtraCharge:false,
            canRemoveExtraCharge:false,
            canAddExtraCharge:false,
            hideCompleteReservationBtn:true,
            warningReservation:false,
            canChangeReservationStatus:false,
            contractType:'',
            pageKey:"",
            insuranceRates:null,
            fromUrl:"",
    }),
    watch:{
        insuranceType: function(value){

            if(value == 0){
                this.phyfromTheir = false;
            }else{
                this.phyfromTheir = true;
            }
        },
        insCompany: function(value){

//            console.log('this one'+value.value);

            if(value.value == 0 ){

                //enable fields
                this.phyCompanyDisabled = true;
                this.phyContactDisabled = 0;
                this.phyContactNameDisabled = 0;
                this.phyEmailDisabled = 0;
                this.phyPolicyNoDisabled = 0;
                this.phyDocumentShow = true;

                this.phyCompanyName  = [];
                this.phyContactName = "";
                this.phyContactNo = "";
                this.phyPolicyNo = "";
                this.phyEmail  = "";

            } else {

                this.phyPolicyNo  = value.policy;
                this.phyContactName = value.agent_contact;
                this.phyEmail = "";
                this.phyContactNo  = value.agent_phone;
                this.phyCompanyName = {'value':value.company_id,'text':value.company_name };

                //disable fields
                this.AllcompanyArr = [];
                this.phyCompanyDisabled = false;
                this.phyContactDisabled = 1;
                this.phyContactNameDisabled = 1;
                this.phyEmailDisabled = 1;
                this.phyPolicyNoDisabled = 1;
                this.phyDocumentShow = false;

            }

        },


        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'view_reservation') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'make_payment') {
                        self.canPay = true;
                    }
                    if (permissions[i].name == 'cancel_reservation') {
                        self.canCancelReservation = true;
                    }
                    if (permissions[i].name == 'add_reservation') {
                        self.canUpdateReservation = true;
                    }
                    if ( permissions[i].name == 'add_extra_charges' ) {
                        self.canAddExtraCharge = true;
                        self.canUpdateExtraCharge = true;
                    }
                    if ( permissions[i].name == 'delete_extra_charges' ) {
                        self.canRemoveExtraCharge = true;
                    }
                    if ( permissions[i].name == 'change_reservation_status' ) {
                        self.canChangeReservationStatus = true;
                    }

                }
            }
        },
        readingOut: function (newVal,oldVal) {

            if ( newVal != oldVal ) {
                $("#updateReadingOutBtn").prop("disabled",false);
            } else {
                $("#updateReadingOutBtn").prop("disabled",true);
            }

        },
        readingIn: function (newVal, oldVal) {

            if ( newVal != oldVal ) {
                $("#updateReadingInBtn").prop("disabled",false);
            } else {
                $("#updateReadingInBtn").prop("disabled",true);
            }
        }

    },
    // props: {
    //     onChange: {
    //         type: Function,
    //     default: function (val) {
    //             this.$emit('input', val)
    //         }
    //     },
    // },
    mounted: function() {
        var self = this;
// console.log("Flag:-->"+ this.$route.params.flag);
        if(this.$route.query.fromUrl){
          self.fromUrl = atob(this.$route.query.fromUrl);
        }

        self.fuelTotal = self.fuelRate * self.gallons;

        var path =  process.env.ROOT_API;

        var imgPath = path.split('/');
//        console.log(imgPath);

        self.basePath = imgPath[0]+'//'+imgPath[2];
//        self.path = imgPath[0]+'//'+imgPath[2] + "/chargesDoc/";
//        self.truckPath = imgPath[0]+'//'+imgPath[2] + "/trucktypeimages/";
        self.invoiceDownPath = imgPath[0]+'//'+imgPath[2] + "/invoices/";
        //check that page is add or update
        this.view_booking_id = this.$route.params.id;
        this.pageKey='_current_reservation_view_'+this.view_booking_id;
        //check user loggged in or not
        var userObj = localStorage.getItem("user_obj");

        //if user logged in than remove login button and registration button
        if (userObj != null) {
            var userJson = JSON.parse(userObj);
            if (userJson.roles.length > 0) {
                this.role = userJson.roles[0].name;

            }
            self.loggedInUser = userJson.id;
            // EventBus.$emit("logged-in", false, userJson["contact"], this.role); //
        }
        //populate rental detail
        this.getBookingDetails();
        //set the page is not profile page

        this.getPermissions();
        // this.getReservationStatus();
        //this.checkInsuranceForCustomer();
        this.getExtraCharges();

        var date = new Date();
        self.currentDate = date.toLocaleDateString("en-US");
    },
    methods:{
        getChargeName(detail){

            var self = this;
            if ( detail && detail.amount != undefined ) {

                self.chargeAmt = detail.amount;
            }
        },
        getExtraCharges: function(){

            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/get_all_extra_charges",
                type: "GET",
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                        // loading(false);
                        self.extraChargesArr = data.content;
                    // if (data.status == "success") {
                    //     alert('hello');


                    // }
                },
                error: function (jqXHR, exception) {
                    loading(false);
                    // $("#settle-btn-"+paymentId).html("<button @click='settlePayment(BookData.bookingId,payment.id)' class=\"btn btn-primary\">Settle Payment</button>");
                    self.generateStatusCodeMessage(jqXHR,true,'reservation-get-extra-charge')
                }
            });
        },
        onSearch(search, loading)
        {
            if (search.length > 1) {
                loading(true);
                this.getInsuranceCompany(loading, search, this);
            }
        },
        getInsuranceCompany: function(loading, search){
            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/get_insurance_company",
                type: "GET",
                crossDomain: true,
                headers: this.ajxHeaders,
                data:{field:search},
                dataType: "json",
                success: function (data) {
                        loading(false);
                    if (data.status == "success") {

                        self.AllcompanyArr = data.content;

                    }
                },
                error: function (jqXHR, exception) {
                    loading(false);
                    // $("#settle-btn-"+paymentId).html("<button @click='settlePayment(BookData.bookingId,payment.id)' class=\"btn btn-primary\">Settle Payment</button>");
                    self.generateStatusCodeMessage(jqXHR,true,'reservation-get-insurance-company')
                }
            });
        },
        BackReservationList() {
            var self = this;
            // self.$router.push("/reservation/list");
          if(self.fromUrl != "" && self.fromUrl != undefined){
            var  selectTab = '?viewTab=equipment';
            var url = self.fromUrl+selectTab;
            self.redirectPageUrl(url);

          } else {
              if(self.contractType == ''){

                if (this.$route.params.flag && this.$route.params.flag == 'getpastreservation'){

                    self.$router.push("/reservation/rental?active=past");

                }else{

                    self.$router.push("/reservation/rental?active=current");

                }

            }
            if(self.contractType != '' && self.contractType == 'Rental'){
                if (this.$route.params.flag && this.$route.params.flag == 'getpastreservation'){

                    self.$router.push("/reservation/rental?active=past");

                }else{

                    self.$router.push("/reservation/rental?active=current");

                }

            }
            if (self.contractType != '' && self.contractType == 'Lease'){
                if (this.$route.params.flag && this.$route.params.flag == 'getpastreservation'){
                    self.$router.push("/reservation/lease?active=past");
                }else{
                    self.$router.push("/reservation/lease?active=current");
                }

            }
          }

        },

        viewInspectionFile:function (path, name) {

            this.$swal({
                imageUrl: path,
                imageHeight: 1000,
                imageWidth: 1000,
                imageAlt: name
            });

        },

        updateReadingOutOrIn:function (reservationId,truckId,flag) {

            var self = this;

            var formData = new FormData();
            self.reading_out_msg = "";
            self.reading_in_msg = "";

//            self.readingIn = $("#readingIn"+ truckId).val();
//            self.readingOut = $("#readingOut" + truckId).val();
            if(flag == 'out'){

                if (!this.readingOut || this.readingOut <= 0) {
                    self.reading_out_msg = "Reading Out Of Miles Must Be Greater Than 0";
                }
                if(this.readingOut && !this.readingOut.match(/^[0-9]*$/)){
                    this.reading_out_msg = "Reading In Of Miles Must Be Numeric";
                }
                if (this.readingOut && this.readingOut.match(/^[0-9]*$/) && this.readingOut > 100000000) {
                    self.reading_out_msg = "Reading Out Of Miles Must Be Less Than 100000000";

                    return;
                }
                if(self.reading_out_msg == ''){

                    $('#updateReadingOutBtn').text("Saving..");
                    $('#updateReadingOutBtn').attr('disabled',true);
                    formData.append('reservationId',reservationId);
                    formData.append('truck_id',truckId);
                    formData.append('readingOut',self.readingOut);
                    formData.append('flag',flag);
//                    console.log(reservationId + " " + truckId + " " + self.readingOut +" " + flag);

                }
            }
            if(flag == 'in'){

                // alert(this.readingOut);
                if (!this.readingIn || this.readingIn <= 0) {
                    self.reading_in_msg = "Reading In Of Miles Must Be Greater Than 0";
                }
                if(this.readingIn && !this.readingIn.match(/^[0-9]*$/)){
                    this.reading_in_msg = "Reading In Of Miles Must Be Numeric";
                    return;
                }
                if(this.readingIn && parseInt(self.readingIn) <= parseInt(self.readingOut)){
                    this.reading_in_msg = "Reading In Miles Must Be Greater Than Reading Out Miles";
                    return;
                }
                if (this.readingIn && this.readingIn.match(/^[0-9]*$/) && this.readingIn > 100000000) {
                    self.reading_in_msg = "Reading In Of Miles Must Be Less Than 100000000";

                    return;
                }
                if(self.reading_in_msg == ''){

                    $('#updateReadingInBtn').text("Saving..");
                    $('#updateReadingInBtn').attr('disabled',true);
                    formData.append('reservationId',reservationId);
                    formData.append('truck_id',truckId);
                    formData.append('readingIn',self.readingIn);
                    formData.append('flag',flag);
//                    console.log(reservationId + " " + truckId + " " + self.readingIn +" " + flag);

                }else{
                    return;
                }
            }
            $.ajax({
                url: process.env.ROOT_API + "/update_reading_out_or_reading_in",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                data: formData,
                dataType: "json",
                processData: false,
                contentType: false,
                success: function (data) {
                    if(data.status == 'success'){
                        self.GetTruckData(reservationId);
                    }
                    if(flag == 'out'){

                        $('#updateReadingOutBtn').text("Save");
                        $('#updateReadingOutBtn').attr('disabled',false);

                        // $("#readingOut"+truckId).val(self.readingOut);
                        ///$("#reading-out" + truckId).toggle();

                    }
                    if(flag == 'in'){

                        $('#updateReadingInBtn').text("Save");
                        $('#updateReadingInBtn').attr('disabled',false);

                        //$("#reading-in" + truckId).toggle();

                    }

                },
                error: function (jqXHR, exception) {

                    if(flag == 'out'){

                        $('#updateReadingOutBtn').text("Save");
                        $('#updateReadingOutBtn').attr('disabled',false);

                    }
                    if(flag == 'in'){

                        $('#updateReadingInBtn').text("Save");
                        $('#updateReadingInBtn').attr('disabled',false);

                    }
                    self.generateStatusCodeMessage(jqXHR,true,'reservation-update-reading-inout')
                }
            });


        },
        updateReservationDetail:function (reservationId,truckId,flag) {

            var self = this;

            self.refError ="";
            self.statusErr = "";
            if(self.CurrentStatus == null){
                self.statusErr = 'Status Required';
                return;
            }
            if(flag == 'status'){
                if(self.CurrentStatus.value == undefined){
                    self.viewStatusInput = false;
                    self.enrichStatusSpan = true;
                    self.editStatusInput = true;
                    return;
                }
            }
            if(flag == 'ref_num'){
                if(self.enrichRefNo == ''){
                    self.refError ="Reference Number Required";
                    return;
                }
            }


            //change button text on click
            // $('#updateTransBtn').text("Processing....");
            // $('#updateTransBtn').attr('disabled',true);

            $.ajax({
                url: process.env.ROOT_API + "/update_reservation_detail",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                data: {
                    status:self.CurrentStatus.value,
                    enrich_transaction_no:self.enrichRefNo,
                    reservationId:reservationId,
                    truckId:truckId,
                    flag:flag
                },
                dataType: "json",
                success: function (data) {

                    // $('#updateTransBtn').text("Save");
                    // $('#updateTransBtn').attr('disabled',false);

                    if(flag == 'status'){
                        self.viewStatusInput = false;
                        self.enrichStatusSpan = true;
                        self.editStatusInput = true;
                    }
                    // self.enrichTransNoText = self.enrichTransNo;
                    if(flag == 'ref_num'){
                        self.viewEnrichInput = false;
                        self.enrichTransNoSpan = true;
                        self.editEnrichInput = true;
                    }

                    self.GetTruckData(reservationId);
                },
                error: function (jqXHR, exception) {

                    // $('#updateTransBtn').text("Save");
                    // $('#updateTransBtn').attr('disabled',false);

                    self.generateStatusCodeMessage(jqXHR,true,'reservation-update-data')
                }
            });

        },

        payExtraCharge:function (bookingId) {

            var self = this;

            //change button text on click
            $('.payChargeBtn').text("Processing....");
            $('.payChargeBtn').attr('disabled',true);

            $.ajax({
                url: process.env.ROOT_API + "/process_payment",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                data: {
                    paymentMethod:'credit_card',
                    bookingId:bookingId,
                    flag:'extraCharge'
                },
                dataType: "json",
                success: function (data) {

                    $('.payChargeBtn').text("Pay Charges");
                    $('.payChargeBtn').attr('disabled',false);

                    if (data.status == "success") {
                        var uId = data.content.uId.split( '=' );

                        localStorage.setItem("uId",uId[1]);
                        localStorage.setItem("sessionId",data.content.sessionId);
                        localStorage.setItem("bookingRef",data.content.bookingRef);
                        self.$router.push("/payment?viewbookings="+bookingId);

                    }

                },
                error: function (jqXHR, exception) {

                    $('.payChargeBtn').text("Pay Charges");
                    $('.payChargeBtn').attr('disabled',false);

                    self.generateStatusCodeMessage(jqXHR,true,'reservation-pay-extra-charge')
                }
            });

        },

        //settle payment
        settlePayment: function (bookingId,truckId,paymentId,event) {

            var self = this;
            var action = $("#settle-btn-"+paymentId).html("Processing ...");

            // action = true;
            // $(event.target).closest("button").find('settle-btn-').html('Processing ...');

            $.ajax({
                url: process.env.ROOT_API + "/send_payment_request",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                data: {bookingId: bookingId,truck_id:truckId},
                dataType: "json",
                success: function (data) {

                    if (data.status == "success") {
                        if ( data.content.procStatus == "0" ) {
                            action = false;
                            $("#settle-btn-"+paymentId).html("NA");
                            $("#payment-status-"+paymentId).html("Processed");
                        } else {
                            alert("There is some error occurred, Please try agin later.");
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    $("#settle-btn-"+paymentId).html("<button @click='settlePayment(BookData.bookingId,payment.id)' class=\"btn btn-primary\">Settle Payment</button>");
                    self.generateStatusCodeMessage(jqXHR,true,'reservation-settle-payment')
                }
            });

        },
        //calculate fuel charge
        updateFuelTotal: function(event) {


            if ( event.target.id == 'fuelRate') {
                this.fuelRate = event.target.value
            } else {
                this.gallons = event.target.value
            }

            this.fuelTotal = this.gallons * this.fuelRate;
        },

        viewFile: function (id, path,type) {

            var self = this;

            self.Invoicefile = path;

            self.$swal({
                imageUrl: self.Invoicefile,
                imageHeight: 1000,
                imageWidth: 1000,
                imageAlt: type
            });

        },

        deleteInsuranceFile: function(file_id, reservationId, truckId) {
            var self = this;
            if (confirm('Are you sure that you want to remove file? ')) {

                self.submitBtn = false;
                //remove from server if user have already uploaded on server
                $.ajax({
                    url: process.env.ROOT_API + "/remove_insurance_data",
                    type: "POST",
                    crossDomain: true,
                    data: {id: file_id},
                    dataType: "json",
                    headers: this.ajxHeaders,
                    success: function (data) {
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {

                            //remove file block
                            self.GetTruckData(reservationId);
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,true,'reservation-remove-insurance-file')
                    }
                });
            }

            return;

        },

        deleteInspectionFile: function(file_id, booking_id) {
            var self = this;

            if (confirm('Are you sure that you want to remove file? ')) {

                //remove from server if user have already uploaded on server
                $.ajax({
                    url: process.env.ROOT_API + "/remove_inspection_data",
                    type: "POST",
                    crossDomain: true,
                    data: {id: file_id, booking_id: booking_id},
                    dataType: "json",
                    success: function (data) {
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {
                            //update local storage for files
                            localStorage.setItem("files", JSON.stringify(data.content));
                            //remove file block
                            $("#fileDiv" + id).remove();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,true,'reservation-remove-inspection-file')
                    }
                });
            }

            return;
            /* check file already uploaded on server or not */
        },

        prevPage: function(){
            var self = this;
            if(self.role != 'customer') {
                self.$router.push("/listbookings");
            }else{
                self.$router.push("/reservationhistory");
            }
        },

        cancelbooking: function(id) {
            var self = this;

            this.$swal({
                title: "Are you sure?",
                text: "Reason for cancellation",
                type: "warning",
                input: "textarea",
                inputOptions:[{text:'reason',value:'reservation ended'}],
                showCancelButton: true,
                confirmButtonText: "Confirm",
                cancelButtonText: "Close",
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then(result => {

                if (result.value) {

                    //getting comment value for reason of cancellation
                    this.comment = JSON.stringify(result.value);

                    $.ajax({
                        url: process.env.ROOT_API + "/cancel_booking",
                        type: "get",
                        crossDomain: true,
                        dataType: "json",
                        headers: this.ajxHeaders,
                        data: {
                            id:id,
                            comment: self.comment,
                            userid:self.loggedInUser
                        },
                        success: function (data) {
                            //console.log(data.content[0]["id"]);
                            if (data.status == "success") {
                                self.getBookingDetails();
                                console.log(data.content);
                                // self.$router.push("/./listbookings");
                            }
                        },
                        error: function (jqXHR, exception) {
                            // self.$router.push("/./listbookings");
                            self.generateStatusCodeMessage(jqXHR,true,'reservation-cancle-booking')
                        }
                    });
                } else if (result.dismiss) {
                    // self.$router.push("/./listbookings");
                }
            });
        },
        //Format value to two decimal point
        numberFormat(amount) {
            return parseFloat(amount).toFixed(2);
        },

        getBookingDetails: function(){

            var self =this;
            self.loading = true;
            var date = new Date();
            var offset = date.getTimezoneOffset();
            if (self.view_booking_id != undefined) {
                //get rental object
                $.ajax({
                    url: process.env.ROOT_API + "/get_booking_data",
                    type: "GET",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    data: {
                        booking_id: self.view_booking_id,
                        offset:offset
                    },
                    success: function(data) {

                        self.loading = false;
//                        console.log(data);
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {
                            // console.log(data.content[0].trucks);
                            self.RentedTrucksArr = data.content;

                            var from = self.$route.query.from;

                            //When no trucks available
                            if ( self.RentedTrucksArr[0].trucks == undefined) {

                                setTimeout(function(){
                                    $("<div style='text-align: center'><h2>There is no truck found<h2></div>").appendTo(".details-page-container");
                                }, 500);

                                // self.$router.push("/reservation/list");
                                self.$router.push("/reservation/rental");


                                return;
                            }

                            // self.GetTruckData(self.RentedTrucksArr[0].trucks[0].reservId);
                            if(localStorage.getItem('reservationId') && localStorage.getItem('reservationId') != 'undefined' && localStorage.getItem('reservationId') != null){
                                self.GetTruckData(localStorage.getItem('reservationId'));
                            } else {
                                self.GetTruckData(self.RentedTrucksArr[0].trucks[0].reservId);
                            }

                        }
                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        $("#myModal").modal("hide");
                        self.generateStatusCodeMessage(jqXHR,true,'reservation-get-booking-detail')
                    }
                });
            }
        },

        openModal: function(chargeObj) {

            var self = this;
//           console.log(chargeObj)

            self.chargesDetails = "";
            self.chargeAmt = "";
            self.files = [];

            self.errorDetails = "";
            self.errorChargeAmt = "";
            // console.log(truck_id);
            $("#extraChargeModal").modal("show");

            if ( chargeObj == '' ) {
                self.modalbtn = 'Add';
                self.doc_path = "";
                self.doc_fileArr = [];
                self.chargeAmt = "";
                self.chargesDetails = "";
                self.files = [];
                self.chargeId = 0;
                self.fileerroor_msg = "";

            } else {

                self.modalbtn = 'Update';
                self.fileerroor_msg = "";
                self.chargesDetails = {value:chargeObj.chargeId,text:chargeObj.chargeName};
                self.chargeAmt = chargeObj.amount;
                self.files = chargeObj.doc_path;
                self.chargeId = chargeObj.id;
            }

        },
        handleFilesUpload: function(event) {
            /* Get the uploaded files from the input.*/
//            alert("hiii")
            var self = this;
            self.filesArr = [];
            // self.files = [];
            self.fileerroor_msg = "";

            let uploadedFiles = "";
            // console.log(self.$refs.phyfiles);
            self.uploadBtn= "Uploading...";
            uploadedFiles = self.$refs.files.files;

            /*
              Adds the uploaded file to the files array
          */
            for (var i = 0; i < uploadedFiles.length; i++) {

                this.filesArr.push(uploadedFiles[i]);
                // self.files.push(uploadedFiles[i]);
            }
//            console.log(this.filesArr);
            // console.log(this.$refs.files.value);
            this.$refs.files.value = '';
            self.uploadBtn= "Upload";
            // this.getImagePreviews();
        },

        createImage(input,file,defects) {

            var self = this;
            defects.show_image_control = false;
            defects.local_image = true;

            var MAX_WIDTH  = 400;
            var MAX_HEIGHT = 300;

            var image = new Image();
            var reader = new FileReader();
            //var vm = this;

            /*reader.onload = (e) => {
                //vm.image['image-'+id] = e.target.result;
                defects.image = e.target.result;
            };*/

            reader.addEventListener("load", function(event) {

                var origImg = new Image();
                origImg.src = event.target.result;

                origImg.addEventListener("load", function(event) {

                    var width  = event.target.width;
                    var height = event.target.height;


                    // Don't resize if it's small enough

                    if (width <= MAX_WIDTH && height <= MAX_HEIGHT) {
                        var canvas = document.createElement('canvas');
                        canvas.width = width;
                        canvas.height = height;

                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(origImg, 0, 0, width, height);

                        defects.image = canvas.toDataURL();
                        //input.src = resizedFile.getAsDataURL();

                        $('[name="defImageComp-'+defects.id+'"]').remove();
                        //elf.formData.append("defImageComp-"+defects.id, resizedFile, 'sample.png');
                        $('<input>').attr({
                            type: 'hidden',
                            id: 'foo',
                            name: "defImageComp-"+defects.id,
                            value: canvas.toDataURL()//encodeURIComponent(canvas.toDataURL())
                        }).appendTo('form');
                    } else {
                        // Calc new dims otherwise

                        if (width > height) {
                            if (width > MAX_WIDTH) {
                                height *= MAX_WIDTH / width;
                                width = MAX_WIDTH;
                            }
                        } else {
                            if (height > MAX_HEIGHT) {
                                width *= MAX_HEIGHT / height;
                                height = MAX_HEIGHT;
                            }
                        }


                        // Resize

                        var canvas = document.createElement('canvas');
                        canvas.width = width;
                        canvas.height = height;

                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(origImg, 0, 0, width, height);

                        // Uncomment below code to get resized file object.
                        /*
                            ToDo : Send File object instead of base64 string.
                            Wanted to append file object to FormData, but facing issues while appending file object.
                                   So for now we are sending base64 string and converting to file object on Server.

                        */
                        // var resizedFile = self.base64ToFile(canvas.toDataURL(), file);

                        defects.image = canvas.toDataURL();
                        //input.src = resizedFile.getAsDataURL();

                        $('[name="defImageComp-'+defects.id+'"]').remove();
                        //elf.formData.append("defImageComp-"+defects.id, resizedFile, 'sample.png');
                        $('<input>').attr({
                            type: 'hidden',
                            id: 'foo',
                            name: "defImageComp-"+defects.id,
                            value: canvas.toDataURL()//encodeURIComponent(canvas.toDataURL())
                        }).appendTo('form');
                    }
                });
            });

            reader.readAsDataURL(file);
        },
        base64ToFile: function(dataURI, origFile){

            var byteString, mimestring;

            if(dataURI.split(',')[0].indexOf('base64') !== -1 ) {
                byteString = atob(dataURI.split(',')[1]);
            } else {
                byteString = decodeURI(dataURI.split(',')[1]);
            }

            mimestring = dataURI.split(',')[0].split(':')[1].split(';')[0];

            var content = new Array();
            for (var i = 0; i < byteString.length; i++) {
                content[i] = byteString.charCodeAt(i);
            }

            var newFile = new File(
                [new Uint8Array(content)], origFile.name, {type: mimestring}
            );


            // Copy props set by the dropzone in the original file

            var origProps = [
                "upload", "status", "previewElement", "previewTemplate", "accepted"
            ];

            $.each(origProps, function(i, p) {
                newFile[p] = origFile[p];
            });

            return newFile;
        },

        updateFuelCharges: function(id) {

            var self = this;

            self.errorChargeAmt = "" ;
            self.errorDetails = "";
            self.fileerroor_msg = "";
//            console.log(self.chargesDetails);
            if ( self.chargesDetails == "" || !self.chargesDetails.value || self.chargesDetails == null ) {
                self.errorDetails = "Please select charge detail" ;
            }
            if ( self.chargeAmt == "" || !self.chargeAmt ) {

                self.errorChargeAmt = "Charge amount is required" ;
                return;
            }
            if(self.chargeAmt && self.chargeAmt < 1 ){
                self.errorChargeAmt = "";
                self.errorChargeAmt = "Other Charges Must Be Greater Than 0";
            }
            if ( self.chargeAmt && !String(self.chargeAmt).match(/^\d+(\.\d*)?$/) ) {
                self.errorChargeAmt = "";
                self.errorChargeAmt = "Other Charges Must Be Numeric";
            }
            if ( self.chargeAmt && String(self.chargeAmt).match(/^\d+(\.\d*)?$/) && self.chargeAmt > 100000 ) {
                self.errorChargeAmt = "";
                self.errorChargeAmt = "Other Charges Must Not Be More Than 100000";
            }

            if ( self.errorChargeAmt == "" && self.errorDetails == "" ) {

                var formData = new FormData();
                formData.append("chargeId", self.chargesDetails.value);
                formData.append("chargeAmount", self.chargeAmt);
                formData.append("resChargeId", id);
                formData.append("resId",self.reservationId);

                if ( this.filesArr.length > 0 ) {

                    if ( this.filesArr.length > 3 ) {
                        self.fileerroor_msg = 'Three Files Allowed At A Time';
                        return;
                    }
                    for ( var i = 0; i < this.filesArr.length; i++ ) {
                        let file = this.filesArr[i];
//                        console.log(file);
                        if ( file.size > 5000000 ) {

                            self.fileerroor_msg = 'File Size Should Not Be Greater Than 5 MB';
                        }
                        if ( file.type == "image/jpeg" || file.type == "image/png" ) {
                        } else {

                            self.fileerroor_msg = 'Only Image Files Are Allowed (.png / .jpeg)';
                        }
                        formData.append("files[]", file);
                    }
                }

                if( self.fileerroor_msg != ""){
                    return;
                }
                if(id != undefined && id != 0){
                    formData.append("flag", 'update');
                }

                $('#updateChargeBtn').text("Processing....");
                $('#updateChargeBtn').attr('disabled', true);

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/update_fuel_charge",
                    type: "POST",
                    crossDomain: true,
                    //dataType: "json",
                    headers: this.ajxHeaders,
                    data : formData,
                    processData: false,
                    contentType: false,
                    success: function (data) {
                        self.loading = false;
                        self.filesArr = [];
                        $('#updateChargeBtn').text("Submit");
                        $('#updateChargeBtn').attr('disabled', false);

                        $("#extraChargeModal").modal("hide");
                        self.GetTruckData(self.reservationId);

                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {
//                            console.log(data.content);
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $('#myButton').text("Add");
                        $('#myButton').attr('disabled', false);
                        self.generateStatusCodeMessage(jqXHR,true,'reservation-update-fuel-charge')
                    }
                });
            }

        },

        SyncInspectionData: function(reservationId, truckId) {
            var self = this;

            $("#syncInspBtn").text("Syncing...");
            $("#syncInspBtn").prop("disabled",true);

            $.ajax({
                url: process.env.ROOT_API + "/sync_inspection_data",
                type: "POST",
                crossDomain: true,
                dataType: "json",
                headers: this.ajxHeaders,
                data: {
                    reservationId: reservationId,
                    truck_id: truckId
                },
                success: function(data) {

                    $("#syncInspBtn").text("Sync Inspection");
                    $("#syncInspBtn").prop("disabled",false);

                    if (data.status == "success") {

                        self.GetTruckData(reservationId);
                    }
                },
                error: function(jqXHR, exception) {
                    self.generateStatusCodeMessage(jqXHR,true,'reservation-sync-inspection-data')
                }
            });
        },
        // calculateFn: function(){
        //     var self = this;
        //
        //     self.calculate = true;
        // },
        addChargesRow: function () {
            this.chargesFields.push(Vue.util.extend({}, this.chargesfield))
        },
        removeField: function(id){
            var self = this;

            if (confirm('Are you sure that you want to remove file? ')) {

                $.ajax({
                    url: process.env.ROOT_API + "/remove_other_charges",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    data: {
                        charges_id:id
                    },
                    success: function(data) {
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {
                            // self.$swal("Deleted!", "Charges Removed.", "success");
                            self.GetTruckData(self.reservationId);
                        }
                    },
                    error: function(jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,true,'reservation-remove-other-charges')
                    }
                });
            }


        },
        viewInvoice:function(id,truckId,flag){

            var self = this;
            if(flag == 'view'){
                $("#invoice_modal .modal-body").html("");
                $("#invoice_modal").modal("show");
            }

            this.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/download_invoice",
                type: "POST",
                crossDomain: true,

                headers: this.ajxHeaders,
                data: {
                    booking_id:id,
                    truck_id:truckId,
                    flag:flag,

                },
                success: function(data) {
                    self.loading = false;
                    // self.Invoicefile  = data.content;
                    if(flag != 'view'){
                        self.Invoicefile = data.content;
                        var save = document.createElement('a');
                        save.href = self.Invoicefile;
                        save.download = self.Invoicefile;
                        save.target = '_blank';
                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);
                    }

                    $("#invoice_modal .modal-body").html(data);

                },
                error: function(jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'reservation-view-inovice')
                }
            });
        },
        openPreAuthModal: function(bookingId){
            var self = this;
            // console.log(bookingId);
            self.bookingId = bookingId;
            self.authToken = true;
            $("#pre_auth_amount_modal").modal("show");
        },
        addPreAuthCharges: function(){
            var self = this;

            self.error = "";
            if(!self.authCharges){
                self.error = "Charges Required";
            }
            if(self.authCharges && !self.authCharges.match(/^\d+/)){
                self.error = "";
                self.error = "Charges Must Be Numeric";
            }
            if(self.error == "") {
                $.ajax({
                    url: process.env.ROOT_API + "/add_pre_authcharges",
                    type: "POST",
                    crossDomain: true,

                    headers: this.ajxHeaders,
                    data: {
                        booking_id: self.bookingId,
                        charges: self.authCharges
                    },
                    success: function (data) {
                        self.loading = false;
                        if (data.status == 'success') {
                            $("#pre_auth_amount_modal").modal("hide");
                            self.getBookingDetails();
                        };

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'reservation-add-pre-charge')
                    }
                });
            }
        },
        paymentProcess: function() {

            var self = this;
            var truck_id = localStorage.getItem('truck_id');

            self.pay_error = "";
            if(!self.amounttopay){
                self.pay_error = "Please Enter Amount To Pay";
                return;
            }
            if(self.amounttopay && self.amounttopay < 1){
                self.pay_error = "Amount Cannot Be Less Than 1";
                return;
            }
            if(self.amounttopay && !self.amounttopay.match(/^[0-9 , '.']*$/)){
                self.pay_error = "Amount to Pay must be Numeric";
                return;
            }

            self.loading = true;
            $('#payment_process_btn').text("Processing....");
            $('#payment_process_btn').attr('disabled',true);

            $.ajax({
                url: process.env.ROOT_API + "/process_payment",
                crossDomain: true,
                type: "POST",
                headers: this.ajxHeaders,
                data: {
                    paymentMethod:'credit_card',
                    bookingId:this.view_booking_id,
                    truckId:truck_id,
                    amount:self.amounttopay,
                    // customer_id:self.checkUser.value,
                    flag:'view'
                },
                success: function (data) {

                    self.loading = false;


                    if (data.status == "success") {
                        var uId = data.content.uId.split( '=' );

                        localStorage.setItem("uId",uId[1]);
                        localStorage.setItem("sessionId",data.content.sessionId);
                        localStorage.setItem("bookingRef",data.content.bookingRef);
                        $("#payCurrentAmount").modal('hide');
                        self.$router.push("/payment?viewbookings="+self.bookingId);


                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'reservation-process-payment')
                }
            });

        },
        viewChargesFile: function(id, path) {
            var self = this;

            self.$swal({
                imageUrl:  path,
                imageHeight: 500,

                imageAlt: "Charges Summary"
            });

        },
        deleteChargesFile: function(key,id,chargeId,file){

            var self = this;

            if (confirm('Are you sure that you want to remove file? ')) {

                if(chargeId != '' && chargeId != undefined && id != undefined ){

                    self.loading = true;

                    $.ajax({
                    url: process.env.ROOT_API + "/remove_charges_file",
                        type: "POST",
                        crossDomain: true,
                        dataType: "json",
                        headers: this.ajxHeaders,
                        data: {
                            charges_id:chargeId,
                            doc_path:file
                        },
                        success: function(data) {
                            self.loading = false;
                            //console.log(data.content[0]["id"]);
                            if (data.status == "success") {
                                // this.files.splice(key,id);
                                // self.$swal("Deleted!", "Your file has been deleted.", "success");
                                self.GetTruckData(self.reservationId);
                                $("#extraChargeModal").modal("hide");
                                self.$refs.files.value = '';
                            }
                        },
                        error: function(jqXHR, exception) {
                            self.loading = false;
                            self.files.splice(key,1);
                            self.generateStatusCodeMessage(jqXHR,true,'reservation-remove-charge-file')
                        }
                    });

                } else{

                    self.filesArr.splice(key,1);
                    self.$refs.files.value = '';
                }
            }

        },

        deleteSelectedTruck: function (resId, bookingId, event) {
            var self = this;

            var options = [];
            // alert(JSON.stringify(inputOptionsPromise));
            $.ajax({
                    url: process.env.ROOT_API + "/get_reasons",
                    type: "GET",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data: {module:'reservation'},
                    dataType: "json",
                    success: function (data) {
                        //console.log(data.content[0]["id"]);
                        options = data;

                        self.$swal({
                                title: "Are you sure?",
                                text: "Reason Of Remove",
                                type: "warning",
                                html:'<input type="textarea" id="swal-input1" class="swal2-input">',
                                // html:'<v-select :options="[text:"reservation",value:"reser"]"></v-select>',
                                input: "select",
                                inputOptions:options,
                                showCancelButton: true,
                                confirmButtonText: "Confirm",
                                cancelButtonText: "Close",
                                showCloseButton: true,
                                showLoaderOnConfirm: true,
                                preConfirm: function (value) {
                                    // alert($("#swal-input1").val());
                                    // var val = true;
                                    return new Promise(function (resolve, reject) {
                                    if(value == 0 && $("#swal-input1").val() == ''){
                                        self.$swal.showValidationError(
                                            'Please Enter Reason.'
                                        )
                                        value = false;
                                    }

                                    resolve(value)
                                    })
                                }
                            }).then(result => {
                                if($("#swal-input1").val() == ''){
                                    $("#swal-input1").val("No Reason");
                            }

                            if (result.value) {

                                //getting comment value for reason of cancellation
                                this.comment = $("#swal-input1").val();
//                                console.log('hello there');
//                                console.log(result.value);
                                var reason_id = result.value;
                                // alert(result.value);

                                $.ajax({
                                    url: process.env.ROOT_API + "/remove_selected_trucks",
                                    type: "POST",
                                    crossDomain: true,
                                    data: {reservationId: resId,reason:this.comment,reason_id:reason_id},
                                    dataType: "json",
                                    success: function (data) {
                                        //console.log(data.content[0]["id"]);
                                        if (data.status == "success") {

                                            self.getBookingDetails(bookingId);
                                            // location.reload();
                                        }
                                    },
                                    error: function (jqXHR, exception) {
                                        self.generateStatusCodeMessage(jqXHR,true,'reservation-remove-inspection-file')
                                    }
                                });

                            } else if (result.dismiss) {
                                // self.$router.push("/./listbookings");
                            }
                        });
                    },
                    error: function (jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,true,'reservation-get-reason')
                    }
                });
        },
        updateReservation: function(){
            var self = this;

            var string = "&for=Reservation&resId="+self.reservationId+"&action=update"+"&url_type=current";
            this.$router.push({ name: 'MakeReservation', query: { data : btoa(string) }});
            // var domain = window.location.hostname;

        },

        addTruck: function(bookingId,custId){
            var self = this;

            localStorage.setItem('booking_id',bookingId);
            localStorage.setItem('customer_id',custId);

            localStorage.removeItem('truck_id');
            self.$router.push({ path:'/' + '?flag=addTruck'});
        },
        handleDocUpload:function(event){
            var self = this;
            self.insDocToken = false;

            // const file = event.target.files[0]
            // console.log(event.target.value);
            var uploadedinsFiles = "";
            uploadedinsFiles = event.target.files;

            for (var i = 0; i < uploadedinsFiles.length; i++) {
                self.selectedFile.push(uploadedinsFiles[i]);
            }
            // self.selectedFile = file;
            event.target.value = "";
            self.submitBtn = true;
        //    console.log(self.selectedFile);
        },
        handleinsFilesUpload: function(type ) {
            /*
              Get the uploaded files from the input.
          */
            var self = this;


            var uploadedinsFiles = "";
            uploadedinsFiles = self.$refs.phyFiles[0].files;
        //     console.log("in.....",uploadedinsFiles);

                for (var i = 0; i < uploadedinsFiles.length; i++) {
                     self.insfile.push(uploadedinsFiles[i]);
                }
                console.log(self.$refs.phyFiles[0].value);
                self.$refs.phyFiles[0].value = '';
                // console.log(self.$refs.$phyFiles[0]);

        },
        submitFiles(id,flag,reservationId,truckId,pickup_date,drop_date) {

            var self = this;
            var error = false;
            var formData = new FormData();

            self.insDocerrors = "";
            self.phypolicyerrors = "";
            self.phynumbererrors = "";
            self.phycompanyerrors = "";
            self.phyDocerrors = "";
            self.phyemailerrors = "";

            if ( flag == 'from_their' ) {


                if ( self.insfile != null ) {
                    console.log(self.insfile.length);

                    if(self.insfile.length > 3){
                        self.phyDocerrors = 'Only Three Files Allowed At A Time';
                        error = true;
                        return;
                    }

                    for (var i = 0; i < self.insfile.length; i++) {

                        let file = this.insfile[i];

                        if ( file.size > 5000000 ) {
                            self.phyDocerrors = 'File size should not be greater than 5 MB';
                            error = true;
                        }
                        // if ( file.type == "image/jpeg" || file.type == "image/png" ) {
                        // } else {
                        //     self.phyDocerrors = 'Only image files are allowed (.png / .jpeg)';
                        //     error = true;
                        // }

                        if ( self.phyDocerrors == "" ) {
                            formData.append("physicalFiles[]", file);
                        }
                    }
                }

                if ( self.phyContactNo && !String(self.phyContactNo).match(/^[0-9]*$/) ) {
                    self.phynumbererrors = "Contact number must be numeric";
                    error = true;
                }
                if ( self.phyContactNo && (self.phyContactNo.length < 10 || self.phyContactNo.length > 12 ) ) {
                    self.phynumbererrors = "Contact number must be between 10 to 12 digits";
                    error = true;
                }
                if ( self.phyEmail && !self.validEmail(self.phyEmail) ) {
                    self.phyemailerrors = "Enter valid Email.";
                    error = true;
                }

                formData.append("physicalinstype", 'from_their');
                if ( self.phyCompanyName.text != undefined ) {
                    formData.append("phyCompanyId", self.phyCompanyName.value );
                } else {
                    formData.append("phyCompanyId", '');
                }

                if ( self.insCompany.value != undefined ) {
                    formData.append("custPolicyId", self.insCompany.value );
                } else {
                    formData.append("custPolicyId", '');
                }

                formData.append("phyContactNo", self.phyContactNo);
                formData.append("phyContactName", self.phyContactName);
                formData.append("phyEmail", self.phyEmail);
                formData.append("phyPolicyNo", self.phyPolicyNo);

            }

            self.insDocerrors = "";

            if(flag == 'from_us'){

                if (self.selectedFile.length > 0) {

                    for (var i = 0; i < self.selectedFile.length; i++) {
                        self.insDocerrors = "";
                        let file = this.selectedFile[i];

                        if ( file.size > 5000000 ) {
                            self.insDocerrors = 'File size should not be greater than 5 MB';
                            error = true;
                        }
                        // if ( file.type == "image/jpeg" || file.type == "image/png" ) {
                        // } else {
                        //     self.phyDocerrors = 'Only image files are allowed (.png / .jpeg)';
                        //     error = true;
                        // }
                        // if (file.size > 5000000) {
                        //     self.insDocerrors = "";
                        //     self.insDocerrors = 'File size should not be greater than 5 MB';
                        //     error = true;
                        // }

                        if ( self.insDocerrors == "" ) {
                            formData.append("physicalinstype", 'from_us');
                            formData.append("insDoc[]", file);
                        }
                    }

                    // if (self.selectedFile.size > 5000000) {
                    //     self.insDocerrors = "";
                    //     self.insDocerrors = 'File size should not be greater than 5 MB';
                    //     error = true;
                    // }
                    // else if(self.selectedFile.type != "image/jpeg" && self.selectedFile.type != "image/png"){
                    //     self.insDocerrors = "";
                    //     self.insDocerrors = 'Only image files are allowed (.png / .jpeg)';
                    //     error = true;
                    // }
                    //  else {

                    //     formData.append("physicalinstype", 'from_us');
                    //     formData.append("insDoc[]", self.selectedFile);
                    // }

                }

                // formData.append("physicalinstype", 'from_us');
            }



            if ( error == false )
            {

                formData.append('pickup_date',pickup_date);
                formData.append('dropoff_date',drop_date);
                formData.append("reservationId", reservationId);
                formData.append("truck_id", truckId);
                formData.append("flag", flag);


                console.log(formData);

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/store_insurance_data",
                    type: "POST",
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    data: formData,
                     headers: this.ajxHeaders,
                    dataType: "json",
                    success: function(data) {
                        self.loading = false;

                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {
                            self.GetTruckData(reservationId);

                            console.log('thisone');

                            if(flag == 'from_their'){
                                self.insfile = [];
                                // self.$refs.phyfiles.value = "";
                            }

                            if(flag == 'from_us'){

                                self.selectedFile = [];
                                self.insDocToken = true;
                                console.log(self.selectedFile);
                            }
                            self.errors.push(data.message);

                        } else if (data.status == "error") {

                            if (data.content.phyContactNo) {
                                self.phynumbererrors.push("Physical damage Contact Number must be of 10 digit");
                                self.loading=false;
                            }
                            if (data.content.phyCompanyName) {
                                self.phycompanyerrors.push(data.content.phyCompanyName);
                                self.loading=false;
                            }

                            console.log($(".error_style").length);
                            self.msgClass = "error";
                        }

                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'reservation-store-insurance')
                    }
                });
            } else {

                console.log($(".error_style").length);
                self.msgClass = "error";
            }
        },
        validEmail: function(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        deleteFromUsDoc: function(key){
            var self = this;
            console.log(self.selectedFile);
            self.insDocToken = true;
            self.selectedFile.splice(key, 1);
//            self.selectedFile = [];
            console.log('after');
            console.log(self.selectedFile);
            self.submitBtn = false;
        },
        deleteInsuranceDoc: function(id,key, type) {
            console.log("id is "+id)
            console.log('key is '+key)
            var self = this;

            if (confirm('Are you sure that you want to remove file? ')) {
                self.submitBtn = false;

                this.insfile.splice(key,1)
                self.$refs.phyFiles[0].value = '';
            }

            return;
        },

        openUpload: function(id){
            var self = this;

            $("#uploadForm"+id).toggle();
        },
        openUpdateinput: function(id,flag){
            var self = this;

            if(flag == 'company'){
                // self.viewEditComForm = true;
                $('#phycompany'+id).show();
            }
            if(flag == 'contact'){
                // self.viewEditComForm = true;
                $('#phycontact'+id).show();
            }
            if(flag == 'liacompany'){
                // self.viewEditComForm = true;
                $('#liacompany'+id).show();
            }
            if(flag == 'liacontact'){
                // self.viewEditComForm = true;
                $('#liacontact'+id).show();
            }
            if(flag == 'comclosein'){
                self.phycompanyerror = "";
                // self.viewEditComForm = true;
                $('#phycompany'+id).hide();
            }
            if(flag == 'conclosein'){
                self.phycontacterror = "";
                // self.viewEditComForm = true;
                $('#phycontact'+id).hide();
            }
            if(flag == 'liacomclosein'){
                self.liacompanyerror = "";
                // self.viewEditComForm = true;
                $('#liacompany'+id).hide();
            }
            if(flag == 'liaconclosein'){
                self.liacontacterror = "";
                // self.viewEditComForm = true;
                $('#liacontact'+id).hide();
            }

        },

        GetTruckData: function(reservationId) {

            var self = this;
            self.reservationId = reservationId;
            self.viewEnrichInput = false;
            self.enrichTransNoSpan = true;
            self.editEnrichInput = true;
            self.loading = true;
            var date = new Date();
            var offset = date.getTimezoneOffset();
            if (self.view_booking_id != undefined) {

                $.ajax({
                    url: process.env.ROOT_API + "/get_truck_data",
                    type: "GET",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    data: {
                        reservation_id: reservationId,
                        //truck_id:truck_id,
                        offset:offset
                    },
                    success: function(data) {
                        console.log(data);

                        //display truck bedge selected
                        $(".truck-badge").removeClass("active");
                        $("#truck_badge_"+reservationId).addClass("active");

                        self.loading = false;
                        // console.log(data.content[0]["id"]);
                        if (data.status == "success") {

                            self.TrucksArr = data.content;
                            self.companyArr = data.content[0].customer_policies;

                            self.contractType = data.content[0].contractType;

                            var phyinstype = data.content[0].phy_insurance_type;

                            if ( phyinstype == 'from_their') {

                                self.phyfromTheir = true;
                                self.insuranceType = 1;

                                if( data.content[0].phyinsfiles.length > 0 ) {

                                    //if policy is selected than display selected
                                    if ( data.content[0].phyinsfiles[0].policy_id ) {
                                        self.insCompany = {'value':data.content[0].phyinsfiles[0].policy_id,'text':data.content[0].phyinsfiles[0].policy_name };
                                    }

                                    setTimeout(function(){
                                        self.phyContactNo = data.content[0].phyinsfiles[0].contact_number;

                                        if ( data.content[0].phyinsfiles[0].company_id != "" ) {
                                            self.phyCompanyName = {'text':data.content[0].phyinsfiles[0].company,'value':data.content[0].phyinsfiles[0].company_id};
                                        }

                                        self.phyContactName = data.content[0].phyinsfiles[0].contact_name;
                                        self.phyEmail = data.content[0].phyinsfiles[0].email;
                                        self.phyPolicyNo = data.content[0].phyinsfiles[0].policy_number;
                                    },1000);

                                } else {
                                    //set defalut null when update insurance type
                                    self.phyContactNo = "";
                                    self.phyCompanyName = [];
                                    self.phyContactName = "";
                                    self.phyEmail = "";
                                    self.phyPolicyNo = "";
                                }

                            } else {
                                self.insuranceType = 0;
                                self.phyfromTheir = false;
                            }

                            self.readingIn = data.content[0].readingIn;
                            self.readingOut =  data.content[0].readingOut;

                            if(self.readingIn > 0 && self.readingOut > 0){
                                self.readingToken = true;
                            }else{
                                self.readingToken = false;
                            }
                            self.insuranceRates= data.content[0].insurance_rates;

                            //disable button
                            setTimeout(function(){
                                $("#updateReadingOutBtn").prop("disabled",true);
                                $("#updateReadingInBtn").prop("disabled",true);
                            }, 500);

                            self.currentReservationAmt = data.content[0].total;
                            var amtType = data.content[0].actual;

                            if(amtType == 'true'){
                                self.amtType = 'Actual'
                            }else{
                                self.amtType = 'Estimated';
                            }
                            self.getTruckInspectionData(data.content[0].reservationId);
                            localStorage.removeItem("reservationId");
                        }
                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        $("#extraChargeModal").modal("hide");
                        self.generateStatusCodeMessage(jqXHR,true,'reservation-get-truck-data')
                    }
                });
            }

        },
        storeActualTotal: function(bookingId){
            var self = this;
            var date = new Date();
            var offset = date.getTimezoneOffset();
            $.ajax({
                url:
                process.env.ROOT_API + "/store_actual_total",
                type: "POST",
                headers: this.ajxHeaders,
                crossDomain: true,
                data: {reservationId:self.reservationId,truck_id:localStorage.getItem('truck_id'),offset:offset},
                dataType: "json",
                success: function (data){

                    self.GetTruckData(self.reservationId);
                },
                error: function (jqXHR, exception) {
                    self.generateStatusCodeMessage(jqXHR,true,'reservation-store-actual-total')
                }
            });
        },
        openPaymentModal:function(bookingId){
            var self = this;
            self.pay_error = '';
            $("#payCurrentAmount").modal('show');

            self.loading = true;
            self.bookingId = bookingId;
            $.ajax({
                url: process.env.ROOT_API + "/get_outstanding_amount",
                type: "GET",
                crossDomain: true,
                headers: this.ajxHeaders,
                data: {
                    booking_id: bookingId,
                    truck_id:localStorage.getItem('truck_id')
                },
                success: function (data) {
                    self.loading = false;
                    if (data.status == 'success') {

                        self.outstandingAmt = self.numberFormat(data.content);
                        // self.currentReservationAmt = self.numberFormat(data.content.total);
                        self.amounttopay = self.numberFormat(data.content);

                    };

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'reservation-get-outstanding')
                }
            });

        },
        // getReservationStatus:  function(){
        //     var self = this;

        //     self.loading = true;
        //     $.ajax({
        //         url: process.env.ROOT_API + "/get_reservation_status",
        //         type: "GET",
        //         crossDomain: true,
        //         headers: {
        //             Accept: "application/json",
        //             Authorization: "Bearer " + localStorage.getItem("tkn"),
        //             "Access-Control-Allow-Headers":
        //                 "Origin, Content-Type, Authorization,X-Requested-With",
        //             "Cache-Control": "no-cache"
        //         },
        //         success: function (data) {
        //             self.loading = false;
        //             if (data.status == 'success') {

        //                 self.statusArr = data.content;
        //             };

        //         },
        //         error: function (jqXHR, exception) {
        //             self.loading = false;
        //             self.generateStatusCodeMessage(jqXHR,true,'reservation-get-reservation-status')
        //         }
        //     });
        // },
        InsuranceCompanyForCustomer: function(comId){

                var self = this;
                var customer = 0;

                $.ajax({
                            url:
                            process.env.ROOT_API +
                            "/find_insurance_company",
                            type: "GET",
                            crossDomain: true,
                            data: {reservation_id:self.view_booking_id,
                                    truck_id:localStorage.getItem('truck_id'),
                                    company_id:comId
                            },
                            dataType: "json",
                            success: function (data) {
                                console.log(data.content);
                                if (data.status == "success") {
                                    // self.companyArr = data.content;
                                    var insData = data.content[0];

                                    self.phyPolicyNo  = insData.policy;
                                    self.phyContactName = insData.agent_name;
                                    self.phyContactNo = insData.agent_phone;
                                    // self.agPhone  = insData.agent_phone;
                                //    localStorage.setItem('ins_flag',data.content);
                                   if(data.flag == true){
                                    self.insBlock = false;
                                    }
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.generateStatusCodeMessage(jqXHR,true,'reservation-insunace-for-customer')
                            }
                        });

            },
            checkInsuranceForCustomer: function(){
                var self = this;
                // var customer = 0;
                // if(self.logrole == 'customer'){
                //     customer = self.loggedinUserId;
                // }else{
                //     customer = localStorage.getItem('customer_id');
                // }

                var pick_date = localStorage.getItem('pickup_date');
                var drop_date = localStorage.getItem('dropoff_date');

                        $.ajax({
                            url:
                            process.env.ROOT_API +
                            "/find_insurance_data",
                            type: "GET",
                            crossDomain: true,
                            data: {reservation_id:self.view_booking_id,
                            truck_id:localStorage.getItem('truck_id'),
                            pick_Date:pick_date,
                            drop_date:drop_date,
                            },
                            dataType: "json",
                            success: function (data) {
                                console.log(data.content);
                                if (data.status == "success") {
                                    self.companyArr = data.company;
                                    self.insCompany = data.company[0];
                                    // self.insCompany.value = data.company[0].value;
                                    var insData = data.content[0];
                                    self.phyPolicyNo  = insData.policy;
                                    self.phyContactName = insData.agent_name;
                                    self.agContact = insData.agent_contact;
                                    self.phyContactNo  = insData.agent_phone;
                                    self.startDate  = insData.start_date;
                                    self.expDate  = insData.expiry_date;
                                //    localStorage.setItem('ins_flag',data.content);
                                   if(data.flag == true){
                                    self.insBlock = false;
                                    }
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.comSelect = false;
                                self.generateStatusCodeMessage(jqXHR,true,'reservation-check-insurance')
                            }
                        });

            },
            fileSize: function(size) {
                var i = Math.floor( Math.log(size) / Math.log(1024) );
                return ( size / Math.pow(1024, i) ).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
            },
            getTruckInspectionData(reservationId) {

                var self = this;

                var pick_date = localStorage.getItem('pickup_date');
                var drop_date = localStorage.getItem('dropoff_date');

                self.pickUpArr = [];
                self.dropOffData = [];

                $.ajax({
                    url: process.env.ROOT_API + "/find_truck_inspection_data",
                    type: "GET",
                    crossDomain: true,
                    data: {
                        reservation_id:reservationId,
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        if(data.status == 'success') {
                            if ( data.content.length > 0 ) {
                                self.pickUpArr = data.content['pickup'];
                                self.dropOffData = data.content['dropoff'];
                            }

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.comSelect = false;
                        self.generateStatusCodeMessage(jqXHR,true,'reservation-find-inspection')
                    }
                });
            },

            confirmCompleteReservation() {

                var self = this;

                self.$swal({
                    title: "Are you sure, Customer credit has not been approved?",
                    text: "",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Complete",
                    cancelButtonText: "Cancel",
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then(result => {

                    if ( result.value ) {
                        self.completeReservation();
                    }

                });

            },

            completeReservation() {

                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/complete_reservation",
                    type: "POST",
                    crossDomain: true,
                    data: {
                        reservation_id:self.reservationId,
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if(data.code == 201){

                            self.warningReservation = true;
                            setTimeout(function(){

                                $('html, body').animate({
                                    scrollTop: $("#alertWarning").offset().top
                                }, 500);

                            },300);

                            setTimeout(function(){

                                self.warningReservation = false;
                            },10000);

                            // self.$swal('',data.message,'info');
                            return;
                        }
                        if(data.status == "success"){

                            var resType='rental';
                            //Checking the type of reservation and based on type redirecting in list page
                            $.each( self.TrucksArr, function( key, truckvalue ) {
                                $.each( truckvalue, function( keyName, value ) {
                                    if(keyName=='contractType'){
                                        resType=value;
                                    }
                                });
                            });
                           if(resType=='Lease'){
                                self.$router.push("/reservation/lease?active=current");
                            }else{
                                self.$router.push("/reservation/rental?active=current");
                            }

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.comSelect = false;
                        self.generateStatusCodeMessage(jqXHR,true,'reservation-compleate-reservation')
                    }
                });

            },

            hideCurrentStatusView: function(value){

                var self = this;
                if(value != ''){
                    //status is Pending
                    if(value.includes("Pending")){
                        self.hideUpdateCurrentStatus = true;
                        self.hideCompleteReservationBtn = false;
                    }else{
                        self.hideUpdateCurrentStatus = true;//disable edit reservation status feature
                        self.hideCompleteReservationBtn = true;
                    }
                }
                return value;   //return current reservation status
        },
        createAgreement: function(id){

            var self = this;

            self.$router.push("/rentalagreement/add?resId="+id)
        },
        viewRentalAgreement:function(id){
            var self = this;
            let routeData = self.$router.resolve({ name:"RentalAgreementView",params:{ id: id}});
            window.open(routeData.href,"_blank");
        }
    }
    };
</script>
<style scoped>
    #updateStatusBtn{
        position:relative;
    }
    /* .inspection-check-list {
        width: auto;
        font-size: 14px;
        color: #666666;
        margin-top: 10px;
        float: left;
        padding: 10px;
    }
    .inspection-check-list p {
        float: left;
    }
    .inspection-check-list img {
        float: left;
        margin-right: 7px;
        margin-top: 3px;
    }
    .inspection-details-internal {
	float: left;
	width: 100%;
	padding: 0px 20px 25px 20px;
}
.inspection-details-internal .insurance-detail-sec {
	float: left;
	width: 45%;
	padding: 18px 15px;
	border-bottom: 1px solid #dddddd;
	margin-right: 50px;
}
.inspection-details-internal .insurance-detail-sec span {
	float: left;
	width: 50%;
	font-size: 15px;
	line-height: 18px;
	padding: 0;
	margin-bottom: 0;
	color: #666666;
	font-family: 'Pangram-Regular';
}
.inspection-details-internal .insurance-detail-sec span {
	float: left;
	width: 50%;
	font-size: 15px;
	line-height: 18px;
	padding: 0;
	margin-bottom: 0;
	color: #666666;
	font-family: 'Pangram-Regular';
}*/
</style>



// WEBPACK FOOTER //
// src/components/Reservation/ReservationContent.vue